const asianRecipes = [
  // ==================== JAPANESE (6) ====================
  {
    title: 'Chicken Teriyaki',
    description:
      'Juicy chicken thighs glazed in a homemade teriyaki sauce with a perfect balance of sweet and savory. This Japanese staple is ready in under 30 minutes and pairs beautifully with steamed rice.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-teriyaki.jpg', caption: 'Glazed chicken teriyaki over rice', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-teriyaki-prep.jpg', caption: 'Slicing chicken thighs', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 20,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Japanese',
    region: 'East Asia',
    country: 'Japan',

    categories: ['Dinner'],
    tags: ['under-30-min', 'high-protein', 'family-friendly', 'weeknight-dinner', 'gluten-free', 'dairy-free'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 380,
      protein: 32,
      carbs: 22,
      fat: 18,
      fiber: 0,
      sugar: 16,
      sodium: 820,
      iron: 1.8,
    },

    ingredients: [
      { qty: 2, unit: 'lbs', item: 'boneless skinless chicken thighs', group: 'Chicken' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Chicken' },
      { qty: 0.5, unit: 'cup', item: 'soy sauce', group: 'Teriyaki Sauce' },
      { qty: 0.25, unit: 'cup', item: 'mirin', group: 'Teriyaki Sauce' },
      { qty: 2, unit: 'tbsp', item: 'sake', group: 'Teriyaki Sauce' },
      { qty: 2, unit: 'tbsp', item: 'brown sugar', group: 'Teriyaki Sauce' },
      { qty: 1, unit: 'tsp', item: 'fresh grated ginger', group: 'Teriyaki Sauce' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Teriyaki Sauce' },
      { qty: 1, unit: 'tsp', item: 'cornstarch mixed with 1 tbsp water', group: 'Teriyaki Sauce' },
      { qty: 1, unit: 'tbsp', item: 'sesame seeds', group: 'Garnish' },
      { qty: 2, unit: 'stalks', item: 'green onion, sliced', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Whisk together soy sauce, mirin, sake, brown sugar, ginger, and garlic in a small bowl. Set aside.', timerMinutes: null },
      { order: 2, instruction: 'Pat chicken thighs dry with paper towels and season lightly with salt and pepper.', timerMinutes: null },
      { order: 3, instruction: 'Heat vegetable oil in a large skillet over medium-high heat. Add chicken thighs and cook without moving for 5 minutes until golden brown on the bottom.', timerMinutes: 5 },
      { order: 4, instruction: 'Flip the chicken and cook the other side for 4 minutes until cooked through (165F internal temperature).', timerMinutes: 4 },
      { order: 5, instruction: 'Pour the teriyaki sauce into the skillet and bring to a simmer. Cook for 3 minutes, turning chicken to coat in the thickening sauce.', timerMinutes: 3 },
      { order: 6, instruction: 'Stir in the cornstarch slurry and cook for 1 minute until the sauce is glossy and clings to the chicken.', timerMinutes: 1 },
      { order: 7, instruction: 'Slice the chicken and serve over steamed rice. Drizzle remaining sauce on top and garnish with sesame seeds and sliced green onion.', timerMinutes: null },
    ],
    notes: 'For a deeper flavor, marinate the chicken in half the sauce for 30 minutes before cooking. Tamari can be substituted for soy sauce to keep this gluten-free.',

    communityRating: 4.7,
    communityRatingCount: 389,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Miso Soup',
    description:
      'A warming, umami-rich Japanese soup made with dashi stock, silky tofu, and wakame seaweed. This comforting bowl is a staple of Japanese home cooking and comes together in just 15 minutes.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/miso-soup.jpg', caption: 'Bowl of miso soup with tofu and scallions', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/miso-soup-prep.jpg', caption: 'Dissolving miso paste into dashi', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Japanese',
    region: 'East Asia',
    country: 'Japan',

    categories: ['Soups & Stews', 'Sides'],
    tags: ['under-15-min', 'vegetarian', 'low-calorie', 'dairy-free', 'comfort-food', 'budget-friendly'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 84,
      protein: 6,
      carbs: 8,
      fat: 3,
      fiber: 1,
      sugar: 3,
      sodium: 790,
      iron: 1.5,
    },

    ingredients: [
      { qty: 4, unit: 'cups', item: 'dashi stock (or water with 1 tsp dashi granules)', group: 'Soup' },
      { qty: 3, unit: 'tbsp', item: 'white miso paste (shiro miso)', group: 'Soup' },
      { qty: 7, unit: 'oz', item: 'soft tofu, cut into 1/2-inch cubes', group: 'Soup' },
      { qty: 2, unit: 'tbsp', item: 'dried wakame seaweed', group: 'Soup' },
      { qty: 2, unit: 'stalks', item: 'green onion, thinly sliced', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Soak the dried wakame in a small bowl of warm water for 5 minutes until rehydrated, then drain.', timerMinutes: 5 },
      { order: 2, instruction: 'Bring the dashi stock to a gentle simmer in a medium saucepan over medium heat. Do not boil.', timerMinutes: null },
      { order: 3, instruction: 'Add the tofu cubes and rehydrated wakame to the simmering dashi. Cook gently for 2 minutes.', timerMinutes: 2 },
      { order: 4, instruction: 'Remove the pot from heat. Place the miso paste in a ladle, submerge it partially in the broth, and whisk to dissolve completely. Never boil miso as it destroys the flavor and probiotics.', timerMinutes: null },
      { order: 5, instruction: 'Ladle into bowls and garnish with sliced green onions. Serve immediately.', timerMinutes: null },
    ],
    notes: 'You can use red (aka) miso for a deeper, saltier flavor or mix red and white for a balanced awase miso soup. Add sliced mushrooms or spinach for extra nutrition.',

    communityRating: 4.5,
    communityRatingCount: 312,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Tonkotsu Ramen',
    description:
      'Rich, creamy pork bone broth simmered for hours, served with springy noodles, chashu pork, a jammy soft-boiled egg, and all the classic toppings. A deeply satisfying bowl worth the effort.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tonkotsu-ramen.jpg', caption: 'Bowl of tonkotsu ramen with chashu and egg', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tonkotsu-ramen-prep.jpg', caption: 'Pork bones simmering in milky broth', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 480,
    totalTime: 510,
    difficulty: 'hard',
    spiceLevel: 1,

    cuisine: 'Japanese',
    region: 'East Asia',
    country: 'Japan',

    categories: ['Dinner', 'Soups & Stews'],
    tags: ['comfort-food', 'high-protein', 'dairy-free', 'sunday-dinner', 'date-night'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 680,
      protein: 38,
      carbs: 62,
      fat: 30,
      fiber: 3,
      sugar: 4,
      sodium: 1100,
      iron: 4.5,
    },

    ingredients: [
      { qty: 3, unit: 'lbs', item: 'pork neck bones or femur bones', group: 'Broth' },
      { qty: 1, unit: 'lb', item: 'pork fatback', group: 'Broth' },
      { qty: 1, unit: '', item: 'whole onion, halved', group: 'Broth' },
      { qty: 6, unit: 'cloves', item: 'garlic, smashed', group: 'Broth' },
      { qty: 2, unit: 'inch', item: 'piece fresh ginger, sliced', group: 'Broth' },
      { qty: 12, unit: 'cups', item: 'water', group: 'Broth' },
      { qty: 1, unit: 'lb', item: 'pork belly, skin on', group: 'Chashu' },
      { qty: 0.5, unit: 'cup', item: 'soy sauce', group: 'Chashu' },
      { qty: 0.5, unit: 'cup', item: 'mirin', group: 'Chashu' },
      { qty: 0.25, unit: 'cup', item: 'sake', group: 'Chashu' },
      { qty: 2, unit: 'tbsp', item: 'sugar', group: 'Chashu' },
      { qty: 4, unit: '', item: 'large eggs', group: 'Toppings' },
      { qty: 18, unit: 'oz', item: 'fresh ramen noodles', group: 'Noodles' },
      { qty: 4, unit: 'stalks', item: 'green onion, sliced', group: 'Toppings' },
      { qty: 1, unit: 'sheet', item: 'nori, cut into 4 pieces', group: 'Toppings' },
      { qty: 4, unit: 'tsp', item: 'sesame oil', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Place pork bones in a large pot, cover with cold water, and bring to a rolling boil. Boil for 10 minutes to remove impurities, then drain and rinse the bones thoroughly under cold water.', timerMinutes: 10 },
      { order: 2, instruction: 'Return cleaned bones and fatback to the pot with 12 cups fresh water, onion, garlic, and ginger. Bring to a vigorous boil, then reduce to a strong simmer. Cook for 7-8 hours, stirring occasionally and adding water as needed to keep bones submerged. The broth should turn creamy and opaque.', timerMinutes: 480 },
      { order: 3, instruction: 'While the broth simmers, prepare the chashu. Roll pork belly tightly and tie with kitchen twine. Combine soy sauce, mirin, sake, and sugar in a saucepan. Add the pork belly, bring to a simmer, cover, and braise for 2 hours, turning occasionally.', timerMinutes: 120 },
      { order: 4, instruction: 'Prepare the soft-boiled eggs. Bring a pot of water to a boil, gently lower in the eggs, and cook for exactly 6 minutes 30 seconds. Transfer to an ice bath immediately. Once cooled, peel and marinate in leftover chashu braising liquid for at least 1 hour.', timerMinutes: 7 },
      { order: 5, instruction: 'Strain the finished broth through a fine-mesh sieve, pressing on the solids. Season with salt to taste. You should have about 8 cups of rich, milky broth.', timerMinutes: null },
      { order: 6, instruction: 'Cook the ramen noodles according to package directions, usually 2-3 minutes. Drain well.', timerMinutes: 3 },
      { order: 7, instruction: 'Slice the chashu into 1/4-inch rounds. Halve the marinated eggs.', timerMinutes: null },
      { order: 8, instruction: 'Divide noodles among 4 bowls. Ladle hot broth over the noodles. Top each bowl with sliced chashu, a halved egg, sliced green onions, a piece of nori, and a drizzle of sesame oil. Serve immediately.', timerMinutes: null },
    ],
    notes: 'The broth can be made a day ahead and refrigerated; the fat will solidify on top and can be skimmed if desired. For a shortcut, use a pressure cooker for 2 hours instead of 8 hours simmering.',

    communityRating: 4.9,
    communityRatingCount: 287,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Gyoza',
    description:
      'Crispy-bottomed Japanese pan-fried dumplings stuffed with a savory mix of pork, cabbage, garlic, and ginger. These addictive little parcels are perfect for sharing with a tangy dipping sauce.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/gyoza.jpg', caption: 'Plate of golden pan-fried gyoza', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/gyoza-prep.jpg', caption: 'Folding gyoza wrappers', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 40,
    cookTime: 15,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Japanese',
    region: 'East Asia',
    country: 'Japan',

    categories: ['Appetizers', 'Dinner', 'Family Meals'],
    tags: ['party', 'family-friendly', 'freezer-friendly', 'make-ahead', 'dairy-free', 'high-protein'],

    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 340,
      protein: 18,
      carbs: 34,
      fat: 14,
      fiber: 2,
      sugar: 2,
      sodium: 620,
      iron: 2.8,
    },

    ingredients: [
      { qty: 0.75, unit: 'lb', item: 'ground pork', group: 'Filling' },
      { qty: 2, unit: 'cups', item: 'napa cabbage, finely minced and squeezed dry', group: 'Filling' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Filling' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Filling' },
      { qty: 2, unit: 'stalks', item: 'green onion, finely chopped', group: 'Filling' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Filling' },
      { qty: 1, unit: '', item: 'egg white', group: 'Filling' },
      { qty: 40, unit: '', item: 'round gyoza wrappers', group: 'Assembly' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Cooking' },
      { qty: 0.5, unit: 'cup', item: 'water', group: 'Cooking' },
      { qty: 3, unit: 'tbsp', item: 'rice vinegar', group: 'Dipping Sauce' },
      { qty: 2, unit: 'tbsp', item: 'soy sauce', group: 'Dipping Sauce' },
      { qty: 1, unit: 'tsp', item: 'chili oil', group: 'Dipping Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'Combine ground pork, squeezed cabbage, garlic, ginger, green onion, soy sauce, sesame oil, and egg white in a large bowl. Mix thoroughly until the filling is sticky and well combined.', timerMinutes: null },
      { order: 2, instruction: 'Place about 1 tablespoon of filling in the center of each gyoza wrapper. Wet the edges with water, fold in half, and pleat one side to seal, creating 5-6 pleats per dumpling. Set on a parchment-lined tray.', timerMinutes: null },
      { order: 3, instruction: 'Heat 1 tablespoon vegetable oil in a large non-stick skillet over medium-high heat. Arrange half the gyoza flat-side down in the pan in a single layer. Cook undisturbed for 2-3 minutes until the bottoms are golden brown.', timerMinutes: 3 },
      { order: 4, instruction: 'Add 1/4 cup water to the pan and immediately cover with a lid. Steam for 4 minutes until the wrappers are translucent and the filling is cooked through.', timerMinutes: 4 },
      { order: 5, instruction: 'Remove the lid and cook for another 1-2 minutes until the water has evaporated and the bottoms are crispy again. Repeat with remaining gyoza.', timerMinutes: 2 },
      { order: 6, instruction: 'Mix together rice vinegar, soy sauce, and chili oil for the dipping sauce. Serve gyoza immediately with the dipping sauce on the side.', timerMinutes: null },
    ],
    notes: 'Uncooked gyoza freeze beautifully. Arrange on a parchment-lined baking sheet, freeze until solid, then transfer to a freezer bag. Cook from frozen by adding an extra minute to the steaming time.',

    communityRating: 4.8,
    communityRatingCount: 421,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Katsu Curry',
    description:
      'Crispy panko-crusted chicken cutlet served alongside a rich, velvety Japanese curry sauce over fluffy white rice. This beloved comfort dish is hearty, warming, and irresistibly satisfying.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/katsu-curry.jpg', caption: 'Chicken katsu curry with rice', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/katsu-curry-prep.jpg', caption: 'Breading chicken cutlets in panko', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 40,
    totalTime: 60,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Japanese',
    region: 'East Asia',
    country: 'Japan',

    categories: ['Dinner', 'Family Meals'],
    tags: ['comfort-food', 'family-friendly', 'high-protein', 'dairy-free', 'weeknight-dinner'],

    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 620,
      protein: 35,
      carbs: 68,
      fat: 22,
      fiber: 4,
      sugar: 8,
      sodium: 780,
      iron: 3.0,
    },

    ingredients: [
      { qty: 4, unit: '', item: 'boneless skinless chicken breasts, pounded to 1/2-inch thick', group: 'Katsu' },
      { qty: 0.5, unit: 'cup', item: 'all-purpose flour', group: 'Katsu' },
      { qty: 2, unit: '', item: 'large eggs, beaten', group: 'Katsu' },
      { qty: 1.5, unit: 'cups', item: 'panko breadcrumbs', group: 'Katsu' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Katsu' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Katsu' },
      { qty: 1, unit: 'cup', item: 'vegetable oil for frying', group: 'Katsu' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Curry Sauce' },
      { qty: 1, unit: '', item: 'large onion, diced', group: 'Curry Sauce' },
      { qty: 2, unit: '', item: 'carrots, peeled and diced', group: 'Curry Sauce' },
      { qty: 2, unit: '', item: 'medium potatoes, peeled and cubed', group: 'Curry Sauce' },
      { qty: 2.5, unit: 'cups', item: 'chicken broth', group: 'Curry Sauce' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Curry Sauce' },
      { qty: 1, unit: 'tbsp', item: 'honey', group: 'Curry Sauce' },
      { qty: 3.5, unit: 'oz', item: 'Japanese curry roux blocks (about half a box)', group: 'Curry Sauce' },
      { qty: 3, unit: 'cups', item: 'cooked Japanese short-grain rice', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Start the curry sauce. Heat 1 tablespoon oil in a large pot over medium heat. Saute the diced onion for 5 minutes until softened. Add carrots and potatoes, stir for 2 minutes.', timerMinutes: 7 },
      { order: 2, instruction: 'Pour in the chicken broth, soy sauce, and honey. Bring to a boil, then reduce heat and simmer covered for 15 minutes until the vegetables are tender.', timerMinutes: 15 },
      { order: 3, instruction: 'Turn off heat and add the curry roux blocks, stirring until fully dissolved. Return to low heat and simmer for 5 more minutes until thickened.', timerMinutes: 5 },
      { order: 4, instruction: 'While the curry simmers, prepare the katsu. Season chicken with salt and pepper. Set up a breading station: flour in one dish, beaten eggs in another, panko in a third.', timerMinutes: null },
      { order: 5, instruction: 'Dredge each chicken breast in flour, dip in egg, then press firmly into panko to coat evenly on all sides.', timerMinutes: null },
      { order: 6, instruction: 'Heat vegetable oil in a large skillet to about 350F (1/2 inch deep). Fry the chicken cutlets for 4-5 minutes per side until golden brown and cooked through (165F internal). Drain on a wire rack.', timerMinutes: 10 },
      { order: 7, instruction: 'Slice each katsu into strips. Serve on a plate with rice on one side, curry sauce ladled over the other side, and the sliced katsu placed on top of the curry.', timerMinutes: null },
    ],
    notes: 'S&B Golden Curry or Vermont Curry are the most common Japanese curry roux brands. For a from-scratch curry, toast 2 tbsp curry powder with 2 tbsp butter and flour, then whisk in broth.',

    communityRating: 4.8,
    communityRatingCount: 356,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Tamagoyaki',
    description:
      'A delicately sweet and savory Japanese rolled omelette with beautiful layered spirals. This classic breakfast and bento box staple showcases the elegant simplicity of Japanese home cooking.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tamagoyaki.jpg', caption: 'Sliced tamagoyaki showing layered spirals', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tamagoyaki-prep.jpg', caption: 'Rolling the omelette in the pan', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Japanese',
    region: 'East Asia',
    country: 'Japan',

    categories: ['Breakfast', 'Sides'],
    tags: ['under-15-min', 'vegetarian', 'low-carb', 'gluten-free', 'lunchbox', 'high-protein'],

    ageGroups: ['toddler', 'kid', 'teen', 'adult'],

    nutrition: {
      calories: 145,
      protein: 10,
      carbs: 4,
      fat: 10,
      fiber: 0,
      sugar: 3,
      sodium: 380,
      iron: 1.4,
    },

    ingredients: [
      { qty: 6, unit: '', item: 'large eggs', group: 'Omelette' },
      { qty: 2, unit: 'tbsp', item: 'dashi stock (or water with a pinch of dashi granules)', group: 'Omelette' },
      { qty: 1, unit: 'tbsp', item: 'mirin', group: 'Omelette' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Omelette' },
      { qty: 0.5, unit: 'tsp', item: 'soy sauce', group: 'Omelette' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Omelette' },
      { qty: 1, unit: 'tsp', item: 'vegetable oil', group: 'Cooking' },
    ],
    steps: [
      { order: 1, instruction: 'Beat the eggs in a bowl, then strain through a fine-mesh sieve for a silky texture. Stir in dashi, mirin, sugar, soy sauce, and salt until well combined.', timerMinutes: null },
      { order: 2, instruction: 'Heat a tamagoyaki pan (or small non-stick skillet) over medium-low heat. Lightly oil with a paper towel dipped in vegetable oil.', timerMinutes: null },
      { order: 3, instruction: 'Pour a thin layer of egg mixture (about 1/4 of the total) into the pan, tilting to spread evenly. When the surface is almost set but still slightly wet, use chopsticks or a spatula to roll the egg from one end to the other.', timerMinutes: 2 },
      { order: 4, instruction: 'Push the rolled egg back to the starting end. Oil the pan again lightly, pour another thin layer of egg, lifting the roll to let egg flow underneath. When almost set, roll again incorporating the first roll. Repeat with remaining egg.', timerMinutes: 5 },
      { order: 5, instruction: 'Transfer the finished roll to a bamboo sushi mat or paper towel. Shape gently into a rectangular log and let it rest for 2 minutes before slicing into 1-inch pieces.', timerMinutes: 2 },
    ],
    notes: 'A rectangular tamagoyaki pan makes this much easier, but a small round non-stick skillet works too. For a savory version, omit the sugar and increase the soy sauce to 1 tsp.',

    communityRating: 4.3,
    communityRatingCount: 178,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ==================== CHINESE (6) ====================
  {
    title: 'Kung Pao Chicken',
    description:
      'A fiery Sichuan classic featuring tender chicken pieces stir-fried with roasted peanuts, dried chilies, and Sichuan peppercorns in a glossy sweet-savory-spicy sauce that tingles the tongue.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/kung-pao-chicken.jpg', caption: 'Kung pao chicken with peanuts and chilies', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/kung-pao-chicken-prep.jpg', caption: 'Dicing chicken and preparing aromatics', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 10,
    totalTime: 25,
    difficulty: 'medium',
    spiceLevel: 4,

    cuisine: 'Chinese',
    region: 'East Asia',
    country: 'China',

    categories: ['Dinner'],
    tags: ['under-30-min', 'high-protein', 'stir-fry', 'dairy-free', 'weeknight-dinner', 'gluten-free'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 420,
      protein: 34,
      carbs: 18,
      fat: 24,
      fiber: 2,
      sugar: 8,
      sodium: 740,
      iron: 2.2,
    },

    ingredients: [
      { qty: 1.5, unit: 'lbs', item: 'boneless skinless chicken thighs, cut into 3/4-inch cubes', group: 'Chicken' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Marinade' },
      { qty: 1, unit: 'tbsp', item: 'Shaoxing wine', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'cornstarch', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'soy sauce', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'Chinkiang black vinegar', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'sugar', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'cornstarch mixed with 2 tbsp water', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Stir-Fry' },
      { qty: 10, unit: '', item: 'dried red chilies, snipped and seeds shaken out', group: 'Stir-Fry' },
      { qty: 1, unit: 'tsp', item: 'Sichuan peppercorns', group: 'Stir-Fry' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Stir-Fry' },
      { qty: 1, unit: 'inch', item: 'piece fresh ginger, minced', group: 'Stir-Fry' },
      { qty: 3, unit: 'stalks', item: 'green onion, cut into 1-inch pieces', group: 'Stir-Fry' },
      { qty: 0.5, unit: 'cup', item: 'roasted unsalted peanuts', group: 'Stir-Fry' },
    ],
    steps: [
      { order: 1, instruction: 'Toss the diced chicken with 1 tbsp soy sauce, Shaoxing wine, and 1 tsp cornstarch. Let marinate for 10 minutes.', timerMinutes: 10 },
      { order: 2, instruction: 'Mix together the sauce ingredients: 2 tbsp soy sauce, black vinegar, sugar, sesame oil, and cornstarch slurry. Set aside.', timerMinutes: null },
      { order: 3, instruction: 'Heat vegetable oil in a wok or large skillet over high heat until smoking. Add the dried chilies and Sichuan peppercorns, stir-fry for 30 seconds until fragrant and darkened.', timerMinutes: 1 },
      { order: 4, instruction: 'Add the marinated chicken in a single layer. Let sear without moving for 1 minute, then stir-fry for 3-4 minutes until cooked through and lightly browned.', timerMinutes: 4 },
      { order: 5, instruction: 'Add garlic and ginger, stir-fry for 30 seconds until fragrant.', timerMinutes: null },
      { order: 6, instruction: 'Pour in the sauce mixture, toss to coat, and cook for 1 minute until the sauce thickens and glazes the chicken.', timerMinutes: 1 },
      { order: 7, instruction: 'Add peanuts and green onion pieces, toss to combine. Serve immediately over steamed rice.', timerMinutes: null },
    ],
    notes: 'For authentic Sichuan flavor, toast whole Sichuan peppercorns in a dry pan, grind, and add to the sauce. Adjust the number of dried chilies to your heat preference. Cashews can substitute for peanuts.',

    communityRating: 4.6,
    communityRatingCount: 345,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Egg Fried Rice',
    description:
      'The ultimate comfort dish made from day-old rice tossed in a screaming hot wok with fluffy eggs, soy sauce, and scallions. Deceptively simple yet endlessly satisfying when done right.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/egg-fried-rice.jpg', caption: 'Plate of golden egg fried rice', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/egg-fried-rice-prep.jpg', caption: 'Breaking up day-old rice', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Chinese',
    region: 'East Asia',
    country: 'China',

    categories: ['Dinner', 'Lunch', 'Sides', 'Family Meals'],
    tags: ['under-15-min', 'vegetarian', 'stir-fry', 'budget-friendly', 'pantry-staples', 'family-friendly', 'weeknight-dinner'],

    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 350,
      protein: 12,
      carbs: 52,
      fat: 10,
      fiber: 1,
      sugar: 2,
      sodium: 580,
      iron: 1.6,
    },

    ingredients: [
      { qty: 4, unit: 'cups', item: 'day-old cooked jasmine rice, cold', group: 'Rice' },
      { qty: 3, unit: '', item: 'large eggs, beaten', group: 'Rice' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Rice' },
      { qty: 2, unit: 'tbsp', item: 'soy sauce', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'white pepper', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 3, unit: 'stalks', item: 'green onion, sliced (white and green parts separated)', group: 'Aromatics' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Aromatics' },
    ],
    steps: [
      { order: 1, instruction: 'Break up the cold rice with your hands or a fork, ensuring no large clumps remain. Cold rice is essential for the best texture.', timerMinutes: null },
      { order: 2, instruction: 'Heat 1 tablespoon vegetable oil in a wok over the highest heat until smoking. Pour in the beaten eggs and scramble quickly for 30 seconds until just set but still soft. Remove to a plate and break into small pieces.', timerMinutes: 1 },
      { order: 3, instruction: 'Add remaining oil to the wok over high heat. Add garlic and the white parts of the green onion, stir-fry for 15 seconds.', timerMinutes: null },
      { order: 4, instruction: 'Add the rice and press it flat against the wok. Let it sear for 30 seconds without stirring, then toss. Repeat this sear-and-toss motion for 3-4 minutes until the rice is heated through and has some lightly charred bits.', timerMinutes: 4 },
      { order: 5, instruction: 'Drizzle soy sauce around the edges of the wok (not directly on the rice) so it hits the hot surface and sizzles. Toss to distribute evenly. Add white pepper and salt.', timerMinutes: null },
      { order: 6, instruction: 'Return the scrambled eggs to the wok, add the green parts of the scallion, and drizzle with sesame oil. Toss everything together and serve immediately.', timerMinutes: null },
    ],
    notes: 'The key to great fried rice is using cold, day-old rice and the highest heat possible. Freshly cooked rice has too much moisture and will turn mushy. Add diced char siu, shrimp, or peas for a heartier version.',

    communityRating: 4.5,
    communityRatingCount: 412,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Mapo Tofu',
    description:
      'Silky soft tofu swimming in a fiery, numbingly spicy sauce of fermented bean paste and ground pork. This iconic Sichuan dish delivers bold, complex flavors with every single bite.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mapo-tofu.jpg', caption: 'Mapo tofu in a clay pot with chili oil', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mapo-tofu-prep.jpg', caption: 'Cubing soft tofu', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 15,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 5,

    cuisine: 'Chinese',
    region: 'East Asia',
    country: 'China',

    categories: ['Dinner'],
    tags: ['under-30-min', 'high-protein', 'one-pan', 'budget-friendly', 'gluten-free', 'dairy-free', 'weeknight-dinner'],

    ageGroups: ['adult'],

    nutrition: {
      calories: 310,
      protein: 22,
      carbs: 12,
      fat: 20,
      fiber: 2,
      sugar: 3,
      sodium: 860,
      iron: 3.8,
    },

    ingredients: [
      { qty: 14, unit: 'oz', item: 'soft or silken tofu, cut into 3/4-inch cubes', group: 'Main' },
      { qty: 0.5, unit: 'lb', item: 'ground pork', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'doubanjiang (fermented chili bean paste)', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'fermented black beans, rinsed and chopped', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Sauce' },
      { qty: 0.75, unit: 'cup', item: 'chicken or vegetable broth', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Cooking' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Aromatics' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, minced', group: 'Aromatics' },
      { qty: 1, unit: 'tbsp', item: 'cornstarch mixed with 2 tbsp water', group: 'Thickener' },
      { qty: 1, unit: 'tsp', item: 'ground Sichuan peppercorn', group: 'Garnish' },
      { qty: 2, unit: 'stalks', item: 'green onion, chopped', group: 'Garnish' },
      { qty: 1, unit: 'tbsp', item: 'chili oil', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Gently place the tofu cubes in a pot of salted simmering water for 2 minutes to warm through and firm up slightly. Drain carefully and set aside.', timerMinutes: 2 },
      { order: 2, instruction: 'Heat vegetable oil in a wok or large skillet over medium-high heat. Add the ground pork and cook, breaking it into small crumbles, for 3-4 minutes until browned.', timerMinutes: 4 },
      { order: 3, instruction: 'Push the pork to one side and add the doubanjiang to the oil. Stir-fry for 1 minute until the oil turns red and fragrant. Add the fermented black beans, garlic, and ginger. Cook for 30 seconds.', timerMinutes: 1 },
      { order: 4, instruction: 'Add the broth and soy sauce. Bring to a simmer. Gently slide in the blanched tofu cubes. Simmer for 5 minutes, gently stirring occasionally.', timerMinutes: 5 },
      { order: 5, instruction: 'Drizzle in the cornstarch slurry while gently stirring. Cook for 1-2 minutes until the sauce thickens and coats the tofu.', timerMinutes: 2 },
      { order: 6, instruction: 'Transfer to a serving bowl. Sprinkle generously with ground Sichuan peppercorn, drizzle with chili oil, and top with chopped green onion. Serve with steamed rice.', timerMinutes: null },
    ],
    notes: 'Pixian doubanjiang is considered the gold standard for this dish. For a vegetarian version, replace pork with rehydrated shiitake mushrooms. The numbing sensation from Sichuan peppercorn is called "ma" and is a hallmark of Sichuan cuisine.',

    communityRating: 4.7,
    communityRatingCount: 268,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Hot and Sour Soup',
    description:
      'A robust Chinese soup that balances the tang of black vinegar with the heat of white pepper, loaded with tofu, mushrooms, and silky egg ribbons. It is the perfect cold-weather comfort bowl.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/hot-and-sour-soup.jpg', caption: 'Steaming bowl of hot and sour soup', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/hot-and-sour-soup-prep.jpg', caption: 'Slicing mushrooms and bamboo shoots', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 15,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 3,

    cuisine: 'Chinese',
    region: 'East Asia',
    country: 'China',

    categories: ['Soups & Stews', 'Appetizers'],
    tags: ['under-30-min', 'low-calorie', 'dairy-free', 'comfort-food', 'one-pot'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 165,
      protein: 12,
      carbs: 14,
      fat: 7,
      fiber: 2,
      sugar: 3,
      sodium: 920,
      iron: 2.0,
    },

    ingredients: [
      { qty: 6, unit: 'cups', item: 'chicken broth', group: 'Soup Base' },
      { qty: 4, unit: 'oz', item: 'firm tofu, cut into thin strips', group: 'Soup Base' },
      { qty: 4, unit: 'oz', item: 'shiitake mushrooms, stems removed, sliced', group: 'Soup Base' },
      { qty: 0.5, unit: 'cup', item: 'bamboo shoots, cut into thin strips', group: 'Soup Base' },
      { qty: 0.25, unit: 'cup', item: 'wood ear mushrooms, rehydrated and sliced', group: 'Soup Base' },
      { qty: 3, unit: 'tbsp', item: 'Chinkiang black vinegar', group: 'Seasoning' },
      { qty: 2, unit: 'tbsp', item: 'soy sauce', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'ground white pepper', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'chili oil or chili flakes', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Seasoning' },
      { qty: 3, unit: 'tbsp', item: 'cornstarch mixed with 1/4 cup cold water', group: 'Thickener' },
      { qty: 1, unit: '', item: 'large egg, beaten', group: 'Egg Ribbons' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Garnish' },
      { qty: 2, unit: 'stalks', item: 'green onion, sliced', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Bring the chicken broth to a boil in a large pot over high heat. Add the shiitake mushrooms, wood ear mushrooms, bamboo shoots, and tofu strips. Simmer for 5 minutes.', timerMinutes: 5 },
      { order: 2, instruction: 'Stir in the soy sauce, black vinegar, white pepper, chili oil, and sugar. Taste and adjust the balance of sour, salty, and spicy to your preference.', timerMinutes: null },
      { order: 3, instruction: 'Give the cornstarch slurry a stir, then pour it into the simmering soup while stirring constantly. Cook for 2 minutes until the soup thickens to a silky consistency.', timerMinutes: 2 },
      { order: 4, instruction: 'With the soup at a gentle simmer, slowly drizzle in the beaten egg in a thin stream while stirring the soup in one direction. The egg will form delicate ribbons.', timerMinutes: null },
      { order: 5, instruction: 'Remove from heat and stir in the sesame oil. Ladle into bowls and garnish with sliced green onions. Serve immediately.', timerMinutes: null },
    ],
    notes: 'Chinkiang (Zhenjiang) black vinegar is essential for authentic flavor -- regular rice vinegar is not a good substitute. Add more white pepper for extra heat or more vinegar for extra tang. Dried lily buds are a traditional addition.',

    communityRating: 4.4,
    communityRatingCount: 198,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Pork Dumplings',
    description:
      'Hand-folded Chinese dumplings with a juicy pork and chive filling, either boiled to be tender and slippery or pan-fried for crispy bottoms. A timeless family dish that brings everyone together.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pork-dumplings.jpg', caption: 'Platter of boiled pork dumplings', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pork-dumplings-prep.jpg', caption: 'Hand-wrapping dumplings', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 45,
    cookTime: 10,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Chinese',
    region: 'East Asia',
    country: 'China',

    categories: ['Dinner', 'Appetizers'],
    tags: ['family-friendly', 'freezer-friendly', 'make-ahead', 'high-protein', 'dairy-free', 'batch-cooking'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 390,
      protein: 22,
      carbs: 38,
      fat: 16,
      fiber: 2,
      sugar: 2,
      sodium: 640,
      iron: 3.2,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'ground pork (not too lean)', group: 'Filling' },
      { qty: 1, unit: 'cup', item: 'Chinese chives or garlic chives, finely chopped', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'soy sauce', group: 'Filling' },
      { qty: 1, unit: 'tbsp', item: 'Shaoxing wine', group: 'Filling' },
      { qty: 1, unit: 'tbsp', item: 'sesame oil', group: 'Filling' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Filling' },
      { qty: 0.25, unit: 'tsp', item: 'white pepper', group: 'Filling' },
      { qty: 3, unit: 'tbsp', item: 'water', group: 'Filling' },
      { qty: 40, unit: '', item: 'round dumpling wrappers', group: 'Assembly' },
      { qty: 3, unit: 'tbsp', item: 'soy sauce', group: 'Dipping Sauce' },
      { qty: 1, unit: 'tbsp', item: 'Chinkiang black vinegar', group: 'Dipping Sauce' },
      { qty: 1, unit: 'tsp', item: 'chili oil', group: 'Dipping Sauce' },
      { qty: 1, unit: 'clove', item: 'garlic, minced', group: 'Dipping Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'In a large bowl, combine ground pork, soy sauce, Shaoxing wine, sesame oil, ginger, and white pepper. Add the water 1 tablespoon at a time, stirring vigorously in one direction after each addition until the filling is sticky and cohesive. Fold in the chives.', timerMinutes: null },
      { order: 2, instruction: 'Place a scant tablespoon of filling in the center of each wrapper. Wet the edges with water, fold in half, and pinch to seal, creating pleats along one side. Place on a floured tray.', timerMinutes: null },
      { order: 3, instruction: 'Bring a large pot of water to a rolling boil. Add the dumplings in batches (do not overcrowd). Stir gently to prevent sticking.', timerMinutes: null },
      { order: 4, instruction: 'When the water returns to a boil, add 1/2 cup cold water. Repeat this two more times (3 boils total). The dumplings are done when they float and the skins look translucent, about 6-8 minutes total.', timerMinutes: 8 },
      { order: 5, instruction: 'While the dumplings cook, mix together the dipping sauce ingredients: soy sauce, black vinegar, chili oil, and minced garlic.', timerMinutes: null },
      { order: 6, instruction: 'Remove dumplings with a slotted spoon and serve immediately with the dipping sauce.', timerMinutes: null },
    ],
    notes: 'Adding water to the filling and stirring in one direction creates a juicy, bouncy texture. For pan-fried dumplings (guotie), follow the same method as gyoza. Freeze uncooked dumplings on a sheet tray, then bag them -- they keep for 3 months.',

    communityRating: 4.7,
    communityRatingCount: 367,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Scallion Pancakes',
    description:
      'Flaky, crispy, and chewy Chinese flatbreads layered with fragrant scallions and sea salt. These irresistible pan-fried pancakes are one of the most beloved street foods in China.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/scallion-pancakes.jpg', caption: 'Golden scallion pancakes cut into wedges', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/scallion-pancakes-prep.jpg', caption: 'Rolling dough with scallion layers', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 20,
    totalTime: 50,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Chinese',
    region: 'East Asia',
    country: 'China',

    categories: ['Snacks', 'Appetizers', 'Sides'],
    tags: ['vegan', 'dairy-free', 'vegetarian', 'party', 'budget-friendly'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 280,
      protein: 6,
      carbs: 38,
      fat: 12,
      fiber: 2,
      sugar: 1,
      sodium: 420,
      iron: 2.4,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'all-purpose flour', group: 'Dough' },
      { qty: 0.75, unit: 'cup', item: 'boiling water', group: 'Dough' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Dough' },
      { qty: 2, unit: 'tbsp', item: 'sesame oil', group: 'Filling' },
      { qty: 1, unit: 'cup', item: 'scallions, finely chopped', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'flaky sea salt', group: 'Filling' },
      { qty: 3, unit: 'tbsp', item: 'vegetable oil for pan-frying', group: 'Cooking' },
    ],
    steps: [
      { order: 1, instruction: 'Place flour and salt in a large bowl. Pour in boiling water while stirring with chopsticks or a fork until a shaggy dough forms. When cool enough to handle, knead on a floured surface for 5 minutes until smooth and elastic. Cover with a damp towel and rest for 30 minutes.', timerMinutes: 30 },
      { order: 2, instruction: 'Divide the dough into 4 equal pieces. Roll one piece into a thin circle about 10 inches in diameter. Brush with sesame oil, sprinkle with sea salt and a quarter of the scallions.', timerMinutes: null },
      { order: 3, instruction: 'Roll the dough up tightly into a log like a jelly roll, then coil the log into a spiral disk. Flatten gently with your palm, then roll out again into a 7-inch circle. Repeat with remaining dough.', timerMinutes: null },
      { order: 4, instruction: 'Heat about 2 teaspoons vegetable oil in a skillet over medium heat. Place one pancake in the pan and cook for 3 minutes until the bottom is golden and crispy.', timerMinutes: 3 },
      { order: 5, instruction: 'Flip and cook for another 2-3 minutes on the other side. Press down gently with a spatula for even contact. Repeat with remaining pancakes, adding oil as needed.', timerMinutes: 3 },
      { order: 6, instruction: 'Cut each pancake into wedges and serve hot. Optionally serve with a dipping sauce of soy sauce mixed with rice vinegar and a drop of chili oil.', timerMinutes: null },
    ],
    notes: 'Using boiling water (hot water dough) makes the pancakes tender and pliable. The coiling technique creates the signature flaky layers. These can be shaped ahead of time and refrigerated between parchment for up to a day.',

    communityRating: 4.6,
    communityRatingCount: 224,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ==================== KOREAN (5) ====================
  {
    title: 'Bibimbap',
    description:
      'A vibrant Korean rice bowl topped with an array of sauteed vegetables, a fried egg, and spicy gochujang sauce, all mixed together at the table for a harmony of flavors, textures, and colors.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bibimbap.jpg', caption: 'Colorful bibimbap bowl with fried egg on top', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bibimbap-prep.jpg', caption: 'Arranged vegetable toppings ready for assembly', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 20,
    totalTime: 50,
    difficulty: 'medium',
    spiceLevel: 3,

    cuisine: 'Korean',
    region: 'East Asia',
    country: 'South Korea',

    categories: ['Dinner', 'Lunch'],
    tags: ['high-protein', 'high-fiber', 'family-friendly', 'meal-prep', 'gluten-free', 'dairy-free'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 520,
      protein: 22,
      carbs: 68,
      fat: 18,
      fiber: 6,
      sugar: 8,
      sodium: 720,
      iron: 4.0,
    },

    ingredients: [
      { qty: 4, unit: 'cups', item: 'cooked short-grain white rice, warm', group: 'Rice' },
      { qty: 0.5, unit: 'lb', item: 'beef sirloin, thinly sliced', group: 'Beef' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Beef' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Beef' },
      { qty: 1, unit: 'clove', item: 'garlic, minced', group: 'Beef' },
      { qty: 2, unit: 'cups', item: 'fresh spinach', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'large carrot, julienned', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'medium zucchini, julienned', group: 'Vegetables' },
      { qty: 4, unit: 'oz', item: 'bean sprouts', group: 'Vegetables' },
      { qty: 4, unit: 'oz', item: 'shiitake mushrooms, sliced', group: 'Vegetables' },
      { qty: 0.5, unit: 'cup', item: 'kimchi', group: 'Vegetables' },
      { qty: 4, unit: '', item: 'large eggs', group: 'Toppings' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Cooking' },
      { qty: 2, unit: 'tsp', item: 'sesame oil', group: 'Cooking' },
      { qty: 3, unit: 'tbsp', item: 'gochujang (Korean chili paste)', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'sesame oil', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'rice vinegar', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'sesame seeds', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Marinate the sliced beef with soy sauce, 1 tsp sesame oil, and garlic for 10 minutes. Mix the gochujang sauce: combine gochujang, sesame oil, rice vinegar, and sugar. Set aside.', timerMinutes: 10 },
      { order: 2, instruction: 'Prepare each vegetable separately. Blanch spinach for 30 seconds, drain, squeeze dry, and season with a pinch of salt and a drizzle of sesame oil. Blanch bean sprouts for 1 minute and season the same way.', timerMinutes: null },
      { order: 3, instruction: 'In a skillet with a little oil over medium-high heat, saute the carrots for 2 minutes. Remove. Saute the zucchini for 2 minutes. Remove. Saute the mushrooms for 3 minutes until golden. Remove each to separate piles.', timerMinutes: 7 },
      { order: 4, instruction: 'In the same pan, cook the marinated beef over high heat for 2-3 minutes until browned and just cooked through. Set aside.', timerMinutes: 3 },
      { order: 5, instruction: 'Fry the eggs sunny-side up in a little oil until the whites are set but the yolks are still runny, about 2-3 minutes each.', timerMinutes: 3 },
      { order: 6, instruction: 'Divide warm rice among 4 bowls. Arrange the vegetables, beef, and kimchi in neat sections on top of the rice. Place a fried egg in the center of each bowl. Sprinkle with sesame seeds.', timerMinutes: null },
      { order: 7, instruction: 'Serve with gochujang sauce on the side. At the table, add the sauce and mix everything together vigorously before eating.', timerMinutes: null },
    ],
    notes: 'For dolsot bibimbap (stone pot version), heat a stone bowl with sesame oil, add rice and toppings, and let it cook until a crispy rice crust forms on the bottom. This is easily made vegetarian by omitting the beef.',

    communityRating: 4.7,
    communityRatingCount: 334,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Bulgogi',
    description:
      'Thinly sliced beef marinated in a sweet and savory blend of soy sauce, pear, sesame oil, and garlic, then grilled or seared to smoky perfection. This beloved Korean barbecue dish is utterly irresistible.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bulgogi.jpg', caption: 'Sizzling bulgogi on a plate with rice', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bulgogi-prep.jpg', caption: 'Marinating thinly sliced beef', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 10,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Korean',
    region: 'East Asia',
    country: 'South Korea',

    categories: ['Dinner'],
    tags: ['under-30-min', 'high-protein', 'dairy-free', 'grilling', 'date-night', 'family-friendly', 'gluten-free'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 380,
      protein: 32,
      carbs: 16,
      fat: 20,
      fiber: 1,
      sugar: 12,
      sodium: 680,
      iron: 3.5,
    },

    ingredients: [
      { qty: 2, unit: 'lbs', item: 'beef ribeye or sirloin, very thinly sliced', group: 'Beef' },
      { qty: 0.25, unit: 'cup', item: 'soy sauce', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'brown sugar', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'sesame oil', group: 'Marinade' },
      { qty: 0.25, unit: '', item: 'Asian pear (or 2 tbsp pear juice), grated', group: 'Marinade' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Marinade' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Marinade' },
      { qty: 1, unit: 'tbsp', item: 'mirin', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Marinade' },
      { qty: 1, unit: '', item: 'medium onion, thinly sliced', group: 'Vegetables' },
      { qty: 3, unit: 'stalks', item: 'green onion, cut into 2-inch pieces', group: 'Vegetables' },
      { qty: 1, unit: 'tbsp', item: 'sesame seeds', group: 'Garnish' },
      { qty: 1, unit: 'head', item: 'butter lettuce, leaves separated (for wraps)', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Partially freeze the beef for 30 minutes to make slicing easier, then cut against the grain into 1/8-inch thin slices. Alternatively, ask your butcher to slice it for you.', timerMinutes: null },
      { order: 2, instruction: 'Combine soy sauce, brown sugar, sesame oil, grated pear, garlic, ginger, mirin, and black pepper in a large bowl. Add the sliced beef and onion, mix well, and marinate for at least 30 minutes (or up to overnight in the refrigerator).', timerMinutes: 30 },
      { order: 3, instruction: 'Heat a cast iron skillet, grill pan, or actual grill to very high heat. Working in batches to avoid overcrowding, cook the beef and onions for 2-3 minutes per batch, turning once, until caramelized and slightly charred.', timerMinutes: 3 },
      { order: 4, instruction: 'Add the green onion pieces in the last minute of cooking and toss to wilt.', timerMinutes: 1 },
      { order: 5, instruction: 'Transfer to a serving plate, sprinkle with sesame seeds, and serve with steamed rice and butter lettuce leaves for wrapping. Pair with kimchi, pickled radish, and ssamjang (dipping paste).', timerMinutes: null },
    ],
    notes: 'Grated Asian pear is the secret to bulgogi; it tenderizes the meat naturally with its enzymes. Freeze the beef briefly before slicing for paper-thin pieces. This also works great as a filling for kimbap or tacos.',

    communityRating: 4.8,
    communityRatingCount: 398,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Kimchi Jjigae',
    description:
      'A hearty, bubbling Korean stew made with well-fermented kimchi, pork belly, and tofu in a deeply savory and spicy broth. This is the ultimate Korean comfort food for cold days.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/kimchi-jjigae.jpg', caption: 'Bubbling pot of kimchi jjigae with tofu', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/kimchi-jjigae-prep.jpg', caption: 'Chopping aged kimchi', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 4,

    cuisine: 'Korean',
    region: 'East Asia',
    country: 'South Korea',

    categories: ['Dinner', 'Soups & Stews'],
    tags: ['one-pot', 'comfort-food', 'high-protein', 'dairy-free', 'gluten-free', 'budget-friendly'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 360,
      protein: 24,
      carbs: 14,
      fat: 24,
      fiber: 3,
      sugar: 5,
      sodium: 980,
      iron: 2.6,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'well-fermented (sour) kimchi, roughly chopped, juice reserved', group: 'Main' },
      { qty: 0.5, unit: 'lb', item: 'pork belly, sliced into bite-size pieces', group: 'Main' },
      { qty: 7, unit: 'oz', item: 'firm tofu, cut into 1/2-inch slabs', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'gochugaru (Korean red pepper flakes)', group: 'Seasoning' },
      { qty: 1, unit: 'tbsp', item: 'gochujang', group: 'Seasoning' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Seasoning' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Aromatics' },
      { qty: 0.5, unit: '', item: 'medium onion, sliced', group: 'Aromatics' },
      { qty: 2, unit: 'cups', item: 'water or anchovy dashi', group: 'Liquid' },
      { qty: 0.25, unit: 'cup', item: 'kimchi juice from the jar', group: 'Liquid' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Seasoning' },
      { qty: 2, unit: 'stalks', item: 'green onion, sliced', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'In a medium pot or Korean stone pot over medium heat, cook the pork belly slices for 3-4 minutes until some fat renders and the edges start to brown.', timerMinutes: 4 },
      { order: 2, instruction: 'Add the chopped kimchi and stir-fry with the pork for 3 minutes until the kimchi softens and becomes fragrant.', timerMinutes: 3 },
      { order: 3, instruction: 'Add garlic, onion, gochugaru, gochujang, soy sauce, and sugar. Stir to combine and cook for 1 minute.', timerMinutes: 1 },
      { order: 4, instruction: 'Pour in the water (or anchovy dashi) and kimchi juice. Bring to a boil, then reduce heat and simmer for 15 minutes to develop the flavors.', timerMinutes: 15 },
      { order: 5, instruction: 'Nestle the tofu slabs into the stew. Simmer for another 5 minutes until the tofu is heated through.', timerMinutes: 5 },
      { order: 6, instruction: 'Garnish with sliced green onions. Serve the stew bubbling hot, directly in the pot, alongside steamed rice.', timerMinutes: null },
    ],
    notes: 'The key to great kimchi jjigae is using well-fermented, sour kimchi -- at least 2-3 weeks old. Fresh kimchi will not give the same depth of flavor. Canned tuna can replace pork for a lighter version.',

    communityRating: 4.6,
    communityRatingCount: 276,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Korean Fried Chicken',
    description:
      'Ultra-crispy double-fried chicken coated in a sticky, sweet-and-spicy gochujang glaze. This addictive KFC-style chicken has a shattering crunch that stays crispy even under the sauce.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/korean-fried-chicken.jpg', caption: 'Glazed Korean fried chicken pieces', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/korean-fried-chicken-prep.jpg', caption: 'Double-frying chicken for extra crunch', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 30,
    totalTime: 50,
    difficulty: 'medium',
    spiceLevel: 3,

    cuisine: 'Korean',
    region: 'East Asia',
    country: 'South Korea',

    categories: ['Dinner', 'Appetizers'],
    tags: ['party', 'game-day', 'high-protein', 'dairy-free', 'comfort-food', 'date-night'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 520,
      protein: 36,
      carbs: 28,
      fat: 30,
      fiber: 1,
      sugar: 14,
      sodium: 840,
      iron: 2.0,
    },

    ingredients: [
      { qty: 2, unit: 'lbs', item: 'chicken wings and drumettes', group: 'Chicken' },
      { qty: 0.5, unit: 'cup', item: 'cornstarch', group: 'Coating' },
      { qty: 0.25, unit: 'cup', item: 'all-purpose flour', group: 'Coating' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Coating' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Coating' },
      { qty: 0.5, unit: 'cup', item: 'cold water', group: 'Coating' },
      { qty: 4, unit: 'cups', item: 'vegetable oil for deep-frying', group: 'Frying' },
      { qty: 3, unit: 'tbsp', item: 'gochujang', group: 'Glaze' },
      { qty: 2, unit: 'tbsp', item: 'soy sauce', group: 'Glaze' },
      { qty: 3, unit: 'tbsp', item: 'honey', group: 'Glaze' },
      { qty: 1, unit: 'tbsp', item: 'rice vinegar', group: 'Glaze' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Glaze' },
      { qty: 1, unit: 'tbsp', item: 'ketchup', group: 'Glaze' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Glaze' },
      { qty: 1, unit: 'tbsp', item: 'sesame seeds', group: 'Garnish' },
      { qty: 2, unit: 'stalks', item: 'green onion, sliced', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Pat chicken wings completely dry. In a bowl, whisk together cornstarch, flour, salt, pepper, and cold water to make a thin batter. Toss the chicken in the batter to coat.', timerMinutes: null },
      { order: 2, instruction: 'Heat vegetable oil to 325F in a large heavy-bottomed pot. Fry the chicken in batches for 8-10 minutes until cooked through but only lightly golden. Remove to a wire rack. This is the first fry.', timerMinutes: 10 },
      { order: 3, instruction: 'Increase oil temperature to 375F. Fry the chicken a second time in batches for 3-4 minutes until deep golden and extremely crispy. Drain on a wire rack.', timerMinutes: 4 },
      { order: 4, instruction: 'While the chicken fries the second time, make the glaze. Combine gochujang, soy sauce, honey, rice vinegar, garlic, ketchup, and sesame oil in a small saucepan. Cook over medium heat for 3-4 minutes, stirring until thickened slightly.', timerMinutes: 4 },
      { order: 5, instruction: 'Toss the hot, crispy chicken in the glaze until evenly coated. Transfer to a serving plate.', timerMinutes: null },
      { order: 6, instruction: 'Sprinkle with sesame seeds and sliced green onions. Serve immediately with pickled radish on the side.', timerMinutes: null },
    ],
    notes: 'The double-frying technique is what gives Korean fried chicken its legendary crunch. The first fry cooks it through, the second fry at higher heat creates the shatteringly crispy exterior. For a soy garlic version, replace gochujang with more soy sauce and extra garlic.',

    communityRating: 4.9,
    communityRatingCount: 445,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Japchae',
    description:
      'A beautiful Korean stir-fried glass noodle dish with colorful vegetables, tender beef, and a sweet soy-sesame dressing. Japchae is a celebration dish that is equally delicious served warm or at room temperature.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/japchae.jpg', caption: 'Japchae glass noodles with vegetables and beef', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/japchae-prep.jpg', caption: 'Stir-frying vegetables separately', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 25,
    cookTime: 20,
    totalTime: 45,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Korean',
    region: 'East Asia',
    country: 'South Korea',

    categories: ['Dinner', 'Sides', 'Family Meals'],
    tags: ['dairy-free', 'high-fiber', 'family-friendly', 'celebration', 'make-ahead', 'gluten-free'],

    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 380,
      protein: 18,
      carbs: 48,
      fat: 14,
      fiber: 4,
      sugar: 10,
      sodium: 640,
      iron: 2.8,
    },

    ingredients: [
      { qty: 8, unit: 'oz', item: 'Korean sweet potato glass noodles (dangmyeon)', group: 'Noodles' },
      { qty: 0.5, unit: 'lb', item: 'beef sirloin, thinly sliced', group: 'Beef' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Beef Marinade' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Beef Marinade' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Beef Marinade' },
      { qty: 1, unit: '', item: 'medium carrot, julienned', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'medium onion, thinly sliced', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'red bell pepper, thinly sliced', group: 'Vegetables' },
      { qty: 4, unit: 'oz', item: 'fresh spinach', group: 'Vegetables' },
      { qty: 4, unit: 'oz', item: 'shiitake mushrooms, sliced', group: 'Vegetables' },
      { qty: 3, unit: 'tbsp', item: 'soy sauce', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'sugar', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'sesame oil', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Cooking' },
      { qty: 1, unit: 'tbsp', item: 'sesame seeds', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Cook the glass noodles in a large pot of boiling water for 6-7 minutes until tender but chewy. Drain, rinse with cold water, and cut with scissors into manageable lengths (about 6-8 inches). Toss with 1 tablespoon of the sauce soy sauce and 1 tablespoon sesame oil.', timerMinutes: 7 },
      { order: 2, instruction: 'Marinate the beef slices with 1 tbsp soy sauce, 1 tsp sesame oil, and 1 tsp sugar for 10 minutes.', timerMinutes: 10 },
      { order: 3, instruction: 'Blanch the spinach in boiling water for 30 seconds, drain, squeeze out excess water, and season with a pinch of salt and a drizzle of sesame oil.', timerMinutes: null },
      { order: 4, instruction: 'Stir-fry each vegetable separately in a bit of oil over high heat for 1-2 minutes until just tender: carrots first, then onion, bell pepper, and mushrooms. Season each lightly with salt. Set aside.', timerMinutes: 8 },
      { order: 5, instruction: 'Stir-fry the marinated beef over high heat for 2-3 minutes until browned. Set aside with the vegetables.', timerMinutes: 3 },
      { order: 6, instruction: 'In a large bowl or the same pan, combine the noodles, all the vegetables, beef, and remaining sauce (2 tbsp soy sauce, 1 tbsp sugar, 1 tbsp sesame oil). Toss gently but thoroughly.', timerMinutes: null },
      { order: 7, instruction: 'Transfer to a serving plate, sprinkle with sesame seeds, and serve warm or at room temperature.', timerMinutes: null },
    ],
    notes: 'The key to japchae is cooking each component separately so everything retains its color and texture. Sweet potato noodles have a wonderful chewy, bouncy texture unlike any other noodle. This dish is traditionally served at Korean celebrations and holidays.',

    communityRating: 4.5,
    communityRatingCount: 212,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ==================== THAI (5) ====================
  {
    title: 'Pad Thai',
    description:
      'Thailand\'s most famous noodle dish featuring stir-fried rice noodles in a tangy-sweet tamarind sauce with shrimp, crunchy peanuts, bean sprouts, and a squeeze of fresh lime.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pad-thai.jpg', caption: 'Classic pad Thai with shrimp and lime', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pad-thai-prep.jpg', caption: 'Soaking rice noodles', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 10,
    totalTime: 25,
    difficulty: 'medium',
    spiceLevel: 2,

    cuisine: 'Thai',
    region: 'Southeast Asia',
    country: 'Thailand',

    categories: ['Dinner'],
    tags: ['under-30-min', 'high-protein', 'stir-fry', 'dairy-free', 'gluten-free', 'weeknight-dinner', 'pescatarian'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 480,
      protein: 26,
      carbs: 56,
      fat: 18,
      fiber: 3,
      sugar: 12,
      sodium: 860,
      iron: 2.4,
    },

    ingredients: [
      { qty: 8, unit: 'oz', item: 'flat rice noodles (pad Thai noodles)', group: 'Noodles' },
      { qty: 1, unit: 'lb', item: 'large shrimp, peeled and deveined', group: 'Protein' },
      { qty: 2, unit: '', item: 'large eggs', group: 'Protein' },
      { qty: 3, unit: 'tbsp', item: 'tamarind paste', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'fish sauce', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'sugar', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'rice vinegar', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'sriracha or sambal oelek', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Cooking' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Aromatics' },
      { qty: 2, unit: 'tbsp', item: 'dried shrimp (optional)', group: 'Aromatics' },
      { qty: 4, unit: 'oz', item: 'firm tofu, pressed and diced small', group: 'Additions' },
      { qty: 1, unit: 'cup', item: 'bean sprouts', group: 'Garnish' },
      { qty: 0.25, unit: 'cup', item: 'roasted peanuts, chopped', group: 'Garnish' },
      { qty: 3, unit: 'stalks', item: 'green onion, cut into 1-inch pieces', group: 'Garnish' },
      { qty: 1, unit: '', item: 'lime, cut into wedges', group: 'Garnish' },
      { qty: 0.25, unit: 'cup', item: 'fresh cilantro leaves', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Soak the rice noodles in warm water for 20-30 minutes until pliable but still firm (they should bend without snapping). Drain well. Mix the sauce ingredients: tamarind paste, fish sauce, sugar, rice vinegar, and sriracha.', timerMinutes: null },
      { order: 2, instruction: 'Heat 1 tablespoon oil in a large wok over high heat. Add the tofu and cook for 2-3 minutes until golden on all sides. Remove. Add the shrimp and cook for 1-2 minutes per side until pink. Remove.', timerMinutes: 4 },
      { order: 3, instruction: 'Add remaining oil to the wok. Add garlic and dried shrimp, stir-fry for 30 seconds. Push to the side, crack the eggs into the wok, and scramble for 30 seconds until just set.', timerMinutes: 1 },
      { order: 4, instruction: 'Add the drained noodles and the sauce to the wok. Toss and stir-fry for 2-3 minutes until the noodles absorb the sauce and are tender. If the noodles stick, add a splash of water.', timerMinutes: 3 },
      { order: 5, instruction: 'Return the shrimp and tofu to the wok. Add the green onion pieces and half the bean sprouts. Toss everything together for 1 minute.', timerMinutes: 1 },
      { order: 6, instruction: 'Plate the pad Thai and top with remaining bean sprouts, chopped peanuts, cilantro, and lime wedges. Serve immediately.', timerMinutes: null },
    ],
    notes: 'Authentic pad Thai uses tamarind paste, not ketchup. Look for seedless tamarind paste in Asian grocery stores. The noodles should be soaked, not boiled, for the best texture. Work in small batches to keep the wok hot enough for a proper stir-fry.',

    communityRating: 4.6,
    communityRatingCount: 402,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Tom Yum Soup',
    description:
      'A hot and sour Thai soup bursting with aromatic lemongrass, galangal, kaffir lime leaves, and plump shrimp. This intensely flavorful broth is simultaneously spicy, sour, and deeply savory.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tom-yum-soup.jpg', caption: 'Aromatic tom yum soup with shrimp', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tom-yum-soup-prep.jpg', caption: 'Bruising lemongrass and preparing aromatics', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 20,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 4,

    cuisine: 'Thai',
    region: 'Southeast Asia',
    country: 'Thailand',

    categories: ['Soups & Stews', 'Dinner'],
    tags: ['low-calorie', 'high-protein', 'dairy-free', 'gluten-free', 'one-pot', 'pescatarian'],

    ageGroups: ['adult'],

    nutrition: {
      calories: 190,
      protein: 24,
      carbs: 10,
      fat: 6,
      fiber: 1,
      sugar: 4,
      sodium: 780,
      iron: 1.8,
    },

    ingredients: [
      { qty: 6, unit: 'cups', item: 'chicken or shrimp stock', group: 'Broth' },
      { qty: 3, unit: 'stalks', item: 'lemongrass, bottom 4 inches bruised and cut into 2-inch pieces', group: 'Aromatics' },
      { qty: 5, unit: 'slices', item: 'galangal (or ginger)', group: 'Aromatics' },
      { qty: 5, unit: '', item: 'kaffir lime leaves, torn', group: 'Aromatics' },
      { qty: 3, unit: '', item: 'Thai bird chilies, smashed', group: 'Aromatics' },
      { qty: 1, unit: 'lb', item: 'large shrimp, peeled and deveined (shells reserved)', group: 'Protein' },
      { qty: 8, unit: 'oz', item: 'straw mushrooms or button mushrooms, halved', group: 'Vegetables' },
      { qty: 2, unit: '', item: 'medium tomatoes, cut into wedges', group: 'Vegetables' },
      { qty: 3, unit: 'tbsp', item: 'fish sauce', group: 'Seasoning' },
      { qty: 3, unit: 'tbsp', item: 'fresh lime juice', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Seasoning' },
      { qty: 2, unit: 'tbsp', item: 'Thai roasted chili paste (nam prik pao)', group: 'Seasoning' },
      { qty: 0.25, unit: 'cup', item: 'fresh cilantro leaves', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Bring the stock to a boil in a large pot. Add the lemongrass, galangal, kaffir lime leaves, and Thai chilies. Simmer for 10 minutes to infuse the aromatics.', timerMinutes: 10 },
      { order: 2, instruction: 'Add the mushrooms and tomatoes. Cook for 3 minutes until the mushrooms are tender.', timerMinutes: 3 },
      { order: 3, instruction: 'Add the shrimp and cook for 2-3 minutes until they turn pink and curl up.', timerMinutes: 3 },
      { order: 4, instruction: 'Remove from heat. Stir in fish sauce, lime juice, sugar, and roasted chili paste. Taste and adjust: it should be equally sour and spicy, with a background of saltiness and sweetness.', timerMinutes: null },
      { order: 5, instruction: 'Ladle into bowls and garnish with fresh cilantro. Serve immediately. The lemongrass, galangal, and kaffir lime leaves are for flavoring and should not be eaten.', timerMinutes: null },
    ],
    notes: 'For tom yum nam khon (creamy version), add 2-3 tablespoons of evaporated milk or coconut milk at the end. Nam prik pao (roasted chili paste) adds a smoky depth; do not skip it. Always add the lime juice off-heat to preserve its brightness.',

    communityRating: 4.5,
    communityRatingCount: 256,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Massaman Curry',
    description:
      'A rich, mild Thai curry with Persian-influenced warm spices, fall-apart tender beef, creamy potatoes, and roasted peanuts in a luscious coconut sauce. This is the curry that won the world over.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/massaman-curry.jpg', caption: 'Massaman curry with beef and potatoes', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/massaman-curry-prep.jpg', caption: 'Toasting spices for the curry', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 90,
    totalTime: 105,
    difficulty: 'medium',
    spiceLevel: 2,

    cuisine: 'Thai',
    region: 'Southeast Asia',
    country: 'Thailand',

    categories: ['Dinner'],
    tags: ['slow-cooker', 'comfort-food', 'high-protein', 'gluten-free', 'dairy-free', 'sunday-dinner', 'make-ahead'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 580,
      protein: 34,
      carbs: 36,
      fat: 34,
      fiber: 5,
      sugar: 10,
      sodium: 720,
      iron: 4.2,
    },

    ingredients: [
      { qty: 2, unit: 'lbs', item: 'beef chuck, cut into 1.5-inch cubes', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'massaman curry paste', group: 'Curry Base' },
      { qty: 2, unit: 'cans', item: '(14 oz each) coconut milk', group: 'Curry Base' },
      { qty: 1, unit: 'cup', item: 'beef broth', group: 'Curry Base' },
      { qty: 2, unit: '', item: 'medium Yukon Gold potatoes, peeled and cut into chunks', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'large onion, cut into wedges', group: 'Vegetables' },
      { qty: 0.25, unit: 'cup', item: 'roasted peanuts', group: 'Additions' },
      { qty: 2, unit: 'tbsp', item: 'fish sauce', group: 'Seasoning' },
      { qty: 2, unit: 'tbsp', item: 'palm sugar or brown sugar', group: 'Seasoning' },
      { qty: 2, unit: 'tbsp', item: 'tamarind paste', group: 'Seasoning' },
      { qty: 3, unit: '', item: 'cardamom pods', group: 'Spices' },
      { qty: 1, unit: '', item: 'cinnamon stick', group: 'Spices' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Spices' },
      { qty: 1, unit: '', item: 'star anise', group: 'Spices' },
      { qty: 4, unit: 'cups', item: 'cooked jasmine rice, for serving', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Open one can of coconut milk and scoop out the thick cream from the top. Heat the cream in a large Dutch oven over medium-high heat. When it begins to separate and sizzle, add the massaman curry paste and stir-fry for 2 minutes until fragrant.', timerMinutes: 2 },
      { order: 2, instruction: 'Add the beef cubes and sear in the curry paste mixture, turning occasionally, for 5 minutes until browned on the outside.', timerMinutes: 5 },
      { order: 3, instruction: 'Pour in the remaining coconut milk, beef broth, and add the cardamom pods, cinnamon stick, bay leaves, and star anise. Bring to a boil, then reduce to a gentle simmer. Cover and cook for 45 minutes.', timerMinutes: 45 },
      { order: 4, instruction: 'Add the potatoes and onion wedges. Continue simmering covered for another 30 minutes until the beef is fork-tender and the potatoes are cooked through.', timerMinutes: 30 },
      { order: 5, instruction: 'Season with fish sauce, palm sugar, and tamarind paste. Stir and let simmer uncovered for 5 minutes. The sauce should be thick and rich. Taste and adjust the balance of salty, sweet, and sour.', timerMinutes: 5 },
      { order: 6, instruction: 'Remove the whole spices (cinnamon stick, star anise, bay leaves, cardamom pods). Stir in the roasted peanuts. Serve over jasmine rice.', timerMinutes: null },
    ],
    notes: 'Massaman curry paste is available in jars at most Asian groceries; Mae Ploy and Maesri are good brands. This curry tastes even better the next day. It also works wonderfully in a slow cooker: combine everything and cook on low for 6-8 hours.',

    communityRating: 4.8,
    communityRatingCount: 310,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Mango Sticky Rice',
    description:
      'Thailand\'s most beloved dessert: warm, sweet coconut sticky rice served with ripe mango slices and drizzled with rich coconut cream. Simple, elegant, and completely irresistible.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mango-sticky-rice.jpg', caption: 'Mango sticky rice with coconut cream drizzle', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mango-sticky-rice-prep.jpg', caption: 'Soaking glutinous rice', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Thai',
    region: 'Southeast Asia',
    country: 'Thailand',

    categories: ['Dessert'],
    tags: ['vegan', 'vegetarian', 'gluten-free', 'dairy-free', 'celebration', 'date-night'],

    ageGroups: ['toddler', 'kid', 'teen', 'adult'],

    nutrition: {
      calories: 420,
      protein: 5,
      carbs: 72,
      fat: 14,
      fiber: 3,
      sugar: 34,
      sodium: 120,
      iron: 1.2,
    },

    ingredients: [
      { qty: 1.5, unit: 'cups', item: 'glutinous (sticky) rice, soaked in water for at least 4 hours', group: 'Rice' },
      { qty: 1, unit: 'can', item: '(14 oz) coconut milk', group: 'Coconut Sauce' },
      { qty: 0.25, unit: 'cup', item: 'sugar', group: 'Coconut Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Coconut Sauce' },
      { qty: 0.25, unit: 'cup', item: 'coconut cream (thick part from top of a chilled can)', group: 'Topping' },
      { qty: 1, unit: 'tbsp', item: 'sugar', group: 'Topping' },
      { qty: 0.125, unit: 'tsp', item: 'salt', group: 'Topping' },
      { qty: 2, unit: '', item: 'large ripe mangoes (Ataulfo or Nam Doc Mai preferred)', group: 'Fruit' },
      { qty: 1, unit: 'tsp', item: 'toasted sesame seeds or mung beans', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Drain the soaked sticky rice and steam it in a steamer basket lined with cheesecloth or a bamboo steamer over boiling water for 20-25 minutes until the grains are translucent and tender.', timerMinutes: 25 },
      { order: 2, instruction: 'While the rice steams, warm the coconut milk with 1/4 cup sugar and 1/2 tsp salt in a saucepan over medium heat, stirring until the sugar dissolves. Do not boil. Remove from heat.', timerMinutes: null },
      { order: 3, instruction: 'Transfer the hot sticky rice to a large bowl. Pour about 3/4 of the warm coconut sauce over the rice and gently fold to combine. Cover and let the rice absorb the sauce for 10-15 minutes.', timerMinutes: 15 },
      { order: 4, instruction: 'In a small saucepan, warm the coconut cream with 1 tbsp sugar and a pinch of salt until dissolved. This is the topping drizzle.', timerMinutes: null },
      { order: 5, instruction: 'Peel the mangoes and slice into elegant pieces. Mound the coconut sticky rice on plates, arrange mango slices alongside, and drizzle with the coconut cream. Sprinkle with toasted sesame seeds.', timerMinutes: null },
    ],
    notes: 'The rice must be soaked for at least 4 hours (overnight is best) for the right sticky texture. Use the ripest, most fragrant mangoes you can find. Ataulfo (honey) mangoes or Thai Nam Doc Mai mangoes are ideal. The remaining coconut sauce can be drizzled on top if desired.',

    communityRating: 4.7,
    communityRatingCount: 283,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Thai Basil Chicken',
    description:
      'A fiery, aromatic Thai street food classic of minced chicken stir-fried with holy basil, chilies, and garlic in a savory-sweet sauce, served over rice with a crispy fried egg on top.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/thai-basil-chicken.jpg', caption: 'Thai basil chicken over rice with fried egg', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/thai-basil-chicken-prep.jpg', caption: 'Mincing chicken and preparing chilies', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 10,
    totalTime: 20,
    difficulty: 'easy',
    spiceLevel: 4,

    cuisine: 'Thai',
    region: 'Southeast Asia',
    country: 'Thailand',

    categories: ['Dinner', 'Lunch'],
    tags: ['under-30-min', 'high-protein', 'stir-fry', 'dairy-free', 'weeknight-dinner', 'budget-friendly', 'one-pan'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 410,
      protein: 30,
      carbs: 38,
      fat: 16,
      fiber: 1,
      sugar: 6,
      sodium: 820,
      iron: 2.6,
    },

    ingredients: [
      { qty: 1.5, unit: 'lbs', item: 'ground chicken (or chicken thighs, minced)', group: 'Chicken' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Aromatics' },
      { qty: 4, unit: '', item: 'Thai bird chilies, finely chopped (adjust to taste)', group: 'Aromatics' },
      { qty: 2, unit: '', item: 'shallots, thinly sliced', group: 'Aromatics' },
      { qty: 2, unit: 'tbsp', item: 'oyster sauce', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'fish sauce', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Cooking' },
      { qty: 2, unit: 'cups', item: 'fresh Thai holy basil leaves (or Thai sweet basil)', group: 'Herbs' },
      { qty: 4, unit: '', item: 'large eggs', group: 'Topping' },
      { qty: 4, unit: 'cups', item: 'cooked jasmine rice', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Mix together the oyster sauce, soy sauce, fish sauce, and sugar in a small bowl. Set aside.', timerMinutes: null },
      { order: 2, instruction: 'Heat 1 tablespoon oil in a wok over high heat until smoking. Add the garlic, chilies, and shallots. Stir-fry for 30 seconds until fragrant.', timerMinutes: null },
      { order: 3, instruction: 'Add the ground chicken and spread it in a single layer. Let it sear for 2 minutes without stirring, then break it up and stir-fry for another 3-4 minutes until cooked through and slightly crispy.', timerMinutes: 5 },
      { order: 4, instruction: 'Pour in the sauce mixture and toss to coat. Cook for 1 minute until the sauce reduces and coats the chicken.', timerMinutes: 1 },
      { order: 5, instruction: 'Remove from heat and fold in the Thai basil leaves. They will wilt from the residual heat.', timerMinutes: null },
      { order: 6, instruction: 'In a separate small pan, fry the eggs in remaining oil over high heat until the edges are crispy and lacy but the yolks are still runny.', timerMinutes: 2 },
      { order: 7, instruction: 'Serve the basil chicken over jasmine rice, topped with a crispy fried egg. The yolk should be broken into the dish when eating.', timerMinutes: null },
    ],
    notes: 'Holy basil (bai krapao) has a spicy, peppery flavor that is different from sweet Thai basil. If you cannot find it, Thai sweet basil works but the dish will taste slightly different. Italian basil is not a good substitute. This dish is called "pad krapao" and is Thailand\'s most popular street food.',

    communityRating: 4.7,
    communityRatingCount: 328,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ==================== VIETNAMESE (4) ====================
  {
    title: 'Pho',
    description:
      'A soul-warming Vietnamese beef noodle soup with an intensely aromatic broth infused with star anise, cinnamon, and charred ginger, ladled over silky rice noodles and topped with fresh herbs.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pho.jpg', caption: 'Bowl of pho with herbs and bean sprouts', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pho-prep.jpg', caption: 'Charring onion and ginger for the broth', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 180,
    totalTime: 200,
    difficulty: 'hard',
    spiceLevel: 1,

    cuisine: 'Vietnamese',
    region: 'Southeast Asia',
    country: 'Vietnam',

    categories: ['Dinner', 'Soups & Stews'],
    tags: ['comfort-food', 'high-protein', 'dairy-free', 'gluten-free', 'sunday-dinner'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 480,
      protein: 32,
      carbs: 52,
      fat: 14,
      fiber: 2,
      sugar: 4,
      sodium: 920,
      iron: 4.6,
    },

    ingredients: [
      { qty: 3, unit: 'lbs', item: 'beef marrow bones', group: 'Broth' },
      { qty: 1, unit: 'lb', item: 'beef chuck or brisket', group: 'Broth' },
      { qty: 1, unit: '', item: 'large onion, halved', group: 'Charred Aromatics' },
      { qty: 4, unit: 'inch', item: 'piece fresh ginger, halved lengthwise', group: 'Charred Aromatics' },
      { qty: 3, unit: '', item: 'star anise', group: 'Spice Sachet' },
      { qty: 4, unit: '', item: 'whole cloves', group: 'Spice Sachet' },
      { qty: 1, unit: '', item: 'cinnamon stick', group: 'Spice Sachet' },
      { qty: 1, unit: 'tsp', item: 'coriander seeds', group: 'Spice Sachet' },
      { qty: 1, unit: 'tsp', item: 'fennel seeds', group: 'Spice Sachet' },
      { qty: 3, unit: 'tbsp', item: 'fish sauce', group: 'Seasoning' },
      { qty: 1, unit: 'tbsp', item: 'sugar', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 14, unit: 'oz', item: 'flat rice noodles (banh pho)', group: 'Noodles' },
      { qty: 0.5, unit: 'lb', item: 'eye of round or sirloin, very thinly sliced (for raw topping)', group: 'Toppings' },
      { qty: 1, unit: 'cup', item: 'bean sprouts', group: 'Table Garnishes' },
      { qty: 1, unit: 'bunch', item: 'fresh Thai basil', group: 'Table Garnishes' },
      { qty: 1, unit: '', item: 'lime, cut into wedges', group: 'Table Garnishes' },
      { qty: 2, unit: '', item: 'jalapenos, thinly sliced', group: 'Table Garnishes' },
      { qty: 0.25, unit: 'cup', item: 'fresh cilantro leaves', group: 'Table Garnishes' },
      { qty: 1, unit: 'tbsp', item: 'hoisin sauce (optional, for serving)', group: 'Table Garnishes' },
      { qty: 1, unit: 'tbsp', item: 'sriracha (optional, for serving)', group: 'Table Garnishes' },
    ],
    steps: [
      { order: 1, instruction: 'Parboil the bones and chuck in a large pot of water for 10 minutes. Drain, rinse the bones thoroughly under cold water, and clean the pot. This removes impurities for a clear broth.', timerMinutes: 10 },
      { order: 2, instruction: 'Char the onion and ginger directly over a gas flame or under the broiler for 5-7 minutes until deeply blackened on all sides. This is critical for the broth flavor.', timerMinutes: 7 },
      { order: 3, instruction: 'Toast the star anise, cloves, cinnamon, coriander, and fennel seeds in a dry pan over medium heat for 2-3 minutes until fragrant. Place in a cheesecloth sachet or tea infuser.', timerMinutes: 3 },
      { order: 4, instruction: 'Return the cleaned bones and chuck to the pot with 12 cups fresh water, charred onion, charred ginger, and the spice sachet. Bring to a boil, reduce to a bare simmer, and cook for 3 hours, skimming any foam that rises.', timerMinutes: 180 },
      { order: 5, instruction: 'After about 1.5 hours, remove the beef chuck when it is tender. Let it cool, then slice thinly across the grain. Continue simmering the broth. Remove and discard the spice sachet after 2 hours total.', timerMinutes: null },
      { order: 6, instruction: 'Strain the broth and season with fish sauce, sugar, and salt. The broth should be clear, fragrant, and deeply flavored. You should have about 8 cups.', timerMinutes: null },
      { order: 7, instruction: 'Cook the rice noodles according to package directions. Divide among 4 large bowls. Top with the cooked sliced chuck and the raw sliced sirloin.', timerMinutes: null },
      { order: 8, instruction: 'Bring the broth to a rolling boil and ladle over the bowls. The boiling broth will cook the raw beef instantly. Serve with the platter of fresh herbs, bean sprouts, lime wedges, jalapenos, hoisin, and sriracha.', timerMinutes: null },
    ],
    notes: 'The key to great pho is a clear, clean broth -- never let it boil vigorously, and always skim impurities. The spice sachet should be removed after 2 hours to prevent bitterness. Ask your butcher to slice the raw topping meat paper-thin, or freeze it briefly before slicing.',

    communityRating: 4.9,
    communityRatingCount: 376,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Banh Mi',
    description:
      'A crispy Vietnamese baguette stuffed with savory marinated pork, tangy pickled vegetables, creamy pate, fresh cilantro, and spicy jalapenos. East meets West in perfect sandwich harmony.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/banh-mi.jpg', caption: 'Loaded banh mi sandwich', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/banh-mi-prep.jpg', caption: 'Pickling daikon and carrots', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 25,
    cookTime: 15,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Vietnamese',
    region: 'Southeast Asia',
    country: 'Vietnam',

    categories: ['Lunch', 'Dinner'],
    tags: ['high-protein', 'dairy-free', 'family-friendly', 'lunchbox', 'make-ahead'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 510,
      protein: 28,
      carbs: 52,
      fat: 22,
      fiber: 3,
      sugar: 10,
      sodium: 860,
      iron: 3.4,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'boneless pork shoulder or pork loin, thinly sliced', group: 'Pork' },
      { qty: 2, unit: 'tbsp', item: 'fish sauce', group: 'Pork Marinade' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Pork Marinade' },
      { qty: 1, unit: 'tbsp', item: 'sugar', group: 'Pork Marinade' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Pork Marinade' },
      { qty: 1, unit: 'tbsp', item: 'lemongrass, minced (or 1 tsp lemongrass paste)', group: 'Pork Marinade' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Pork Marinade' },
      { qty: 1, unit: '', item: 'large daikon radish (about 6 inches), julienned', group: 'Pickled Vegetables' },
      { qty: 2, unit: '', item: 'medium carrots, julienned', group: 'Pickled Vegetables' },
      { qty: 0.5, unit: 'cup', item: 'rice vinegar', group: 'Pickled Vegetables' },
      { qty: 0.5, unit: 'cup', item: 'warm water', group: 'Pickled Vegetables' },
      { qty: 3, unit: 'tbsp', item: 'sugar', group: 'Pickled Vegetables' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Pickled Vegetables' },
      { qty: 4, unit: '', item: 'Vietnamese or French baguette rolls (about 8 inches each)', group: 'Assembly' },
      { qty: 4, unit: 'tbsp', item: 'pate (chicken liver pate)', group: 'Assembly' },
      { qty: 4, unit: 'tbsp', item: 'mayonnaise', group: 'Assembly' },
      { qty: 1, unit: '', item: 'English cucumber, sliced lengthwise', group: 'Assembly' },
      { qty: 1, unit: '', item: 'jalapeno, thinly sliced', group: 'Assembly' },
      { qty: 0.5, unit: 'cup', item: 'fresh cilantro sprigs', group: 'Assembly' },
    ],
    steps: [
      { order: 1, instruction: 'Combine the pork with fish sauce, soy sauce, sugar, garlic, lemongrass, and oil. Marinate for at least 20 minutes (or up to overnight).', timerMinutes: 20 },
      { order: 2, instruction: 'Make the quick pickles: dissolve sugar and salt in warm water and rice vinegar. Add the julienned daikon and carrot. Let sit for at least 20 minutes (they will become more flavorful over time). Drain before using.', timerMinutes: 20 },
      { order: 3, instruction: 'Cook the pork in a hot skillet or grill pan over high heat for 2-3 minutes per side until caramelized and cooked through.', timerMinutes: 6 },
      { order: 4, instruction: 'Split the baguette rolls lengthwise (not all the way through) and lightly toast in the oven at 375F for 3-4 minutes until the exterior is crispy but the interior stays soft.', timerMinutes: 4 },
      { order: 5, instruction: 'Spread pate on one side of the bread and mayonnaise on the other. Layer in the grilled pork, drained pickled vegetables, cucumber slices, jalapeno slices, and cilantro sprigs.', timerMinutes: null },
      { order: 6, instruction: 'Press the sandwich gently closed and serve immediately.', timerMinutes: null },
    ],
    notes: 'The baguette should have a thin, shattering crust and a light, airy crumb -- not dense like European sourdough. Vietnamese bakeries make the best ones, but French baguette rolls work well. Pate is traditional and adds a rich, savory element. The pickled vegetables can be made up to a week ahead.',

    communityRating: 4.6,
    communityRatingCount: 298,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Fresh Spring Rolls',
    description:
      'Light, refreshing Vietnamese rice paper rolls filled with shrimp, vermicelli noodles, crisp vegetables, and fragrant herbs, served with a rich peanut dipping sauce. A vibrant no-cook appetizer.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/fresh-spring-rolls.jpg', caption: 'Fresh spring rolls with peanut dipping sauce', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/fresh-spring-rolls-prep.jpg', caption: 'Rolling ingredients in rice paper', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 5,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Vietnamese',
    region: 'Southeast Asia',
    country: 'Vietnam',

    categories: ['Appetizers', 'Lunch'],
    tags: ['no-cook', 'low-calorie', 'high-protein', 'gluten-free', 'dairy-free', 'pescatarian', 'party', 'under-30-min'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 240,
      protein: 16,
      carbs: 32,
      fat: 6,
      fiber: 3,
      sugar: 5,
      sodium: 520,
      iron: 1.8,
    },

    ingredients: [
      { qty: 12, unit: '', item: 'rice paper wrappers (8.5-inch rounds)', group: 'Wrappers' },
      { qty: 0.75, unit: 'lb', item: 'cooked shrimp, halved lengthwise', group: 'Filling' },
      { qty: 4, unit: 'oz', item: 'rice vermicelli noodles, cooked and cooled', group: 'Filling' },
      { qty: 1, unit: '', item: 'head butter lettuce, leaves separated', group: 'Filling' },
      { qty: 1, unit: '', item: 'English cucumber, julienned', group: 'Filling' },
      { qty: 1, unit: '', item: 'large carrot, julienned', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'fresh mint leaves', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'fresh cilantro leaves', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'fresh Thai basil leaves', group: 'Filling' },
      { qty: 3, unit: 'tbsp', item: 'creamy peanut butter', group: 'Peanut Sauce' },
      { qty: 2, unit: 'tbsp', item: 'hoisin sauce', group: 'Peanut Sauce' },
      { qty: 1, unit: 'tbsp', item: 'sriracha', group: 'Peanut Sauce' },
      { qty: 2, unit: 'tbsp', item: 'warm water', group: 'Peanut Sauce' },
      { qty: 1, unit: 'tsp', item: 'rice vinegar', group: 'Peanut Sauce' },
      { qty: 1, unit: 'tbsp', item: 'crushed roasted peanuts', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Prepare all the filling ingredients and arrange them on a large platter for easy assembly. Cook the rice vermicelli according to package directions, rinse with cold water, and drain well.', timerMinutes: null },
      { order: 2, instruction: 'Make the peanut sauce by whisking together peanut butter, hoisin sauce, sriracha, warm water, and rice vinegar until smooth. Add more water if needed for a dippable consistency. Top with crushed peanuts.', timerMinutes: null },
      { order: 3, instruction: 'Fill a large shallow dish with warm water. Dip one rice paper wrapper in the water for about 10 seconds, rotating gently, until it is just pliable (it will continue to soften). Lay flat on a clean damp surface.', timerMinutes: null },
      { order: 4, instruction: 'On the bottom third of the wrapper, layer a lettuce leaf, a small bundle of vermicelli, cucumber, carrot, and herbs. Place 3-4 shrimp halves in a line above the filling (these will show through the translucent wrapper).', timerMinutes: null },
      { order: 5, instruction: 'Fold the bottom of the wrapper up over the filling, then fold in both sides tightly like a burrito. Continue rolling up to the top edge, keeping it tight. The wrapper will seal to itself.', timerMinutes: null },
      { order: 6, instruction: 'Repeat with remaining wrappers and filling. Serve immediately with the peanut dipping sauce. Cover assembled rolls with a damp towel if not serving right away.', timerMinutes: null },
    ],
    notes: 'Do not over-soak the rice paper -- it should still feel slightly firm when you remove it from the water, as it will continue to soften. If making ahead, wrap each roll individually in plastic wrap and refrigerate for up to 4 hours. For a nut-free sauce, use a nuoc cham dipping sauce made with fish sauce, lime, sugar, garlic, and chili.',

    communityRating: 4.4,
    communityRatingCount: 256,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Vietnamese Coffee',
    description:
      'Rich, bold Vietnamese coffee brewed slowly through a traditional phin filter and mixed with sweetened condensed milk for a decadently creamy, intensely caffeinated treat served over ice.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/vietnamese-coffee.jpg', caption: 'Vietnamese iced coffee with condensed milk', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/vietnamese-coffee-prep.jpg', caption: 'Phin filter dripping coffee', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Vietnamese',
    region: 'Southeast Asia',
    country: 'Vietnam',

    categories: ['Drinks & Smoothies'],
    tags: ['under-15-min', 'vegetarian', 'gluten-free', '5-ingredients-or-less', 'make-ahead'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 180,
      protein: 3,
      carbs: 28,
      fat: 5,
      fiber: 0,
      sugar: 26,
      sodium: 50,
      iron: 0.4,
    },

    ingredients: [
      { qty: 4, unit: 'tbsp', item: 'Vietnamese ground coffee (Trung Nguyen or Cafe du Monde)', group: 'Coffee' },
      { qty: 1.5, unit: 'cups', item: 'boiling water (just off the boil at around 200F)', group: 'Coffee' },
      { qty: 4, unit: 'tbsp', item: 'sweetened condensed milk', group: 'Milk' },
      { qty: 2, unit: 'cups', item: 'ice cubes', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Place 1 tablespoon of sweetened condensed milk in the bottom of each of 4 heatproof glasses or cups.', timerMinutes: null },
      { order: 2, instruction: 'Add 1 tablespoon of ground coffee to each phin filter. Gently press down with the filter press. Place the filter on top of the glass.', timerMinutes: null },
      { order: 3, instruction: 'Add a small splash of hot water (about 1 tablespoon) to bloom the coffee. Wait 30 seconds for the grounds to expand.', timerMinutes: 1 },
      { order: 4, instruction: 'Fill each phin filter with about 1/3 cup boiling water. Cover with the lid and let the coffee drip slowly through, about 5-7 minutes. The slow drip is what gives Vietnamese coffee its distinctive strong flavor.', timerMinutes: 7 },
      { order: 5, instruction: 'Remove the phin filter. Stir the coffee and condensed milk together until well combined. Fill tall glasses with ice cubes and pour the coffee mixture over the ice.', timerMinutes: null },
    ],
    notes: 'If you do not have a phin filter, use a very strong French press brew (double the normal amount of coffee). Cafe du Monde coffee with chicory is a popular and widely available choice. For a hot version, skip the ice. Adjust the condensed milk to your sweetness preference.',

    communityRating: 4.3,
    communityRatingCount: 142,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ==================== INDIAN (4) ====================
  {
    title: 'Butter Chicken',
    description:
      'Tender tandoori-spiced chicken simmered in a velvety, mildly spiced tomato and butter sauce enriched with cream. This iconic North Indian dish is rich, aromatic, and universally beloved.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/butter-chicken.jpg', caption: 'Butter chicken with naan bread', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/butter-chicken-prep.jpg', caption: 'Marinating chicken in yogurt spice mixture', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 35,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 2,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: ['high-protein', 'comfort-food', 'family-friendly', 'gluten-free', 'weeknight-dinner', 'date-night'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 490,
      protein: 36,
      carbs: 14,
      fat: 32,
      fiber: 3,
      sugar: 8,
      sodium: 680,
      iron: 3.4,
    },

    ingredients: [
      { qty: 2, unit: 'lbs', item: 'boneless skinless chicken thighs, cut into 2-inch pieces', group: 'Chicken Marinade' },
      { qty: 0.5, unit: 'cup', item: 'plain whole-milk yogurt', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Chicken Marinade' },
      { qty: 2, unit: 'tsp', item: 'garam masala', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tsp', item: 'turmeric', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tsp', item: 'chili powder (Kashmiri for color)', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Chicken Marinade' },
      { qty: 3, unit: 'tbsp', item: 'butter', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Sauce' },
      { qty: 1, unit: '', item: 'large onion, finely diced', group: 'Sauce' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Sauce' },
      { qty: 1, unit: 'can', item: '(14 oz) crushed tomatoes', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'garam masala', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'ground coriander', group: 'Sauce' },
      { qty: 0.5, unit: 'cup', item: 'heavy cream', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'sugar', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Combine the chicken pieces with yogurt, lemon juice, garam masala, turmeric, chili powder, and salt. Marinate for at least 30 minutes (or overnight in the refrigerator for best results).', timerMinutes: 30 },
      { order: 2, instruction: 'Heat oil in a large skillet over high heat. Remove chicken from marinade, shaking off excess, and sear in batches for 2-3 minutes per side until charred spots form. The chicken does not need to be cooked through. Set aside.', timerMinutes: 6 },
      { order: 3, instruction: 'In the same pan, melt butter over medium heat. Add the diced onion and cook for 5 minutes until softened and golden. Add garlic and ginger, cook for 1 minute until fragrant.', timerMinutes: 6 },
      { order: 4, instruction: 'Add garam masala, cumin, and coriander. Toast the spices for 30 seconds. Pour in the crushed tomatoes and sugar. Simmer for 10 minutes, stirring occasionally, until the sauce thickens.', timerMinutes: 10 },
      { order: 5, instruction: 'Use an immersion blender or transfer to a blender to puree the sauce until smooth. Return to the pan and stir in the heavy cream.', timerMinutes: null },
      { order: 6, instruction: 'Add the seared chicken pieces to the sauce. Simmer gently for 12-15 minutes until the chicken is cooked through and the sauce has thickened to a rich, velvety consistency.', timerMinutes: 15 },
      { order: 7, instruction: 'Taste and adjust salt and sugar. Garnish with fresh cilantro and serve with basmati rice or warm naan bread.', timerMinutes: null },
    ],
    notes: 'Kashmiri chili powder gives the classic deep red-orange color without too much heat. For a richer sauce, add an extra tablespoon of butter at the end (this is called "finishing" with butter). The sauce can be made a day ahead and reheated with the chicken.',

    communityRating: 4.8,
    communityRatingCount: 432,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Dal Tadka',
    description:
      'Comforting yellow lentils slow-simmered until creamy, then finished with a sizzling tempered spice mixture of cumin, mustard seeds, garlic, and dried chilies. This is everyday Indian soul food.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/dal-tadka.jpg', caption: 'Creamy dal tadka with tempered spices', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/dal-tadka-prep.jpg', caption: 'Tempering spices in ghee', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 35,
    totalTime: 45,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner', 'Sides'],
    tags: ['vegan', 'vegetarian', 'high-protein', 'high-fiber', 'gluten-free', 'budget-friendly', 'one-pot', 'comfort-food', 'meal-prep'],

    ageGroups: ['toddler', 'kid', 'teen', 'adult'],

    nutrition: {
      calories: 280,
      protein: 16,
      carbs: 40,
      fat: 7,
      fiber: 12,
      sugar: 4,
      sodium: 460,
      iron: 4.8,
    },

    ingredients: [
      { qty: 1, unit: 'cup', item: 'yellow lentils (toor dal or chana dal), rinsed', group: 'Dal' },
      { qty: 3, unit: 'cups', item: 'water', group: 'Dal' },
      { qty: 0.5, unit: 'tsp', item: 'turmeric', group: 'Dal' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Dal' },
      { qty: 1, unit: '', item: 'medium tomato, diced', group: 'Dal' },
      { qty: 1, unit: '', item: 'green chili, slit lengthwise', group: 'Dal' },
      { qty: 2, unit: 'tbsp', item: 'ghee (or vegetable oil for vegan)', group: 'Tadka (Tempering)' },
      { qty: 1, unit: 'tsp', item: 'cumin seeds', group: 'Tadka (Tempering)' },
      { qty: 0.5, unit: 'tsp', item: 'mustard seeds', group: 'Tadka (Tempering)' },
      { qty: 2, unit: '', item: 'dried red chilies', group: 'Tadka (Tempering)' },
      { qty: 8, unit: '', item: 'fresh curry leaves', group: 'Tadka (Tempering)' },
      { qty: 0.25, unit: 'tsp', item: 'asafoetida (hing)', group: 'Tadka (Tempering)' },
      { qty: 3, unit: 'cloves', item: 'garlic, thinly sliced', group: 'Tadka (Tempering)' },
      { qty: 1, unit: '', item: 'small onion, finely diced', group: 'Tadka (Tempering)' },
      { qty: 2, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Garnish' },
      { qty: 1, unit: 'tsp', item: 'lemon juice', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Rinse the lentils in several changes of water until the water runs clear. Combine lentils, 3 cups water, turmeric, and salt in a pot. Bring to a boil, skimming any foam, then reduce to a simmer.', timerMinutes: null },
      { order: 2, instruction: 'Simmer the lentils partially covered for 25-30 minutes, stirring occasionally, until they are completely soft and broken down into a creamy consistency. Add the diced tomato and green chili in the last 10 minutes. Add more water if the dal is too thick.', timerMinutes: 30 },
      { order: 3, instruction: 'Mash some of the lentils with the back of a spoon for a creamier texture while leaving some whole for body.', timerMinutes: null },
      { order: 4, instruction: 'Prepare the tadka: heat ghee in a small pan over medium heat. Add cumin seeds and mustard seeds. When they start to pop and splutter, add the dried red chilies, curry leaves (careful, they will splatter), asafoetida, and sliced garlic.', timerMinutes: 1 },
      { order: 5, instruction: 'Add the diced onion to the tadka and cook for 2-3 minutes until golden. The whole tadka should be sizzling and incredibly fragrant.', timerMinutes: 3 },
      { order: 6, instruction: 'Pour the sizzling tadka directly over the pot of cooked dal. It should sizzle and sputter dramatically. Stir to combine, add lemon juice, and garnish with fresh cilantro. Serve with steamed basmati rice or roti.', timerMinutes: null },
    ],
    notes: 'The "tadka" or tempering is what elevates simple lentils to something spectacular. The key is getting the oil hot enough that the spices bloom instantly. Use an Instant Pot or pressure cooker to reduce the dal cooking time to 10 minutes. For a vegan version, use oil instead of ghee.',

    communityRating: 4.5,
    communityRatingCount: 264,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Palak Paneer',
    description:
      'Cubes of fresh paneer cheese in a vibrant, silky spinach sauce spiced with cumin, coriander, and garam masala. This North Indian vegetarian classic is nutritious, comforting, and packed with iron.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/palak-paneer.jpg', caption: 'Creamy palak paneer with naan', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/palak-paneer-prep.jpg', caption: 'Blanching spinach for the sauce', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 25,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: ['vegetarian', 'high-protein', 'high-iron', 'gluten-free', 'comfort-food', 'weeknight-dinner'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 360,
      protein: 20,
      carbs: 12,
      fat: 26,
      fiber: 4,
      sugar: 3,
      sodium: 520,
      iron: 5.6,
    },

    ingredients: [
      { qty: 14, unit: 'oz', item: 'paneer, cut into 3/4-inch cubes', group: 'Paneer' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Paneer' },
      { qty: 1, unit: 'lb', item: 'fresh baby spinach (or frozen spinach, thawed)', group: 'Spinach Sauce' },
      { qty: 2, unit: 'tbsp', item: 'butter or ghee', group: 'Spinach Sauce' },
      { qty: 1, unit: '', item: 'medium onion, diced', group: 'Spinach Sauce' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Spinach Sauce' },
      { qty: 1, unit: 'inch', item: 'piece fresh ginger, grated', group: 'Spinach Sauce' },
      { qty: 1, unit: '', item: 'green chili, chopped', group: 'Spinach Sauce' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'garam masala', group: 'Spices' },
      { qty: 0.25, unit: 'tsp', item: 'turmeric', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Spices' },
      { qty: 3, unit: 'tbsp', item: 'heavy cream', group: 'Finishing' },
      { qty: 1, unit: 'tsp', item: 'lemon juice', group: 'Finishing' },
    ],
    steps: [
      { order: 1, instruction: 'Blanch the spinach in a large pot of boiling water for 2 minutes until wilted. Immediately transfer to an ice bath to preserve the bright green color. Squeeze dry and puree in a blender until smooth.', timerMinutes: 2 },
      { order: 2, instruction: 'Heat oil in a non-stick pan over medium-high heat. Pan-fry the paneer cubes for 2-3 minutes, turning occasionally, until golden on several sides. Remove and set aside.', timerMinutes: 3 },
      { order: 3, instruction: 'In the same pan, melt butter over medium heat. Saute the onion for 4-5 minutes until softened. Add garlic, ginger, and green chili. Cook for 1 minute.', timerMinutes: 6 },
      { order: 4, instruction: 'Add cumin, coriander, garam masala, turmeric, and salt. Toast the spices for 30 seconds until fragrant.', timerMinutes: null },
      { order: 5, instruction: 'Pour in the spinach puree and stir to combine. Simmer for 5 minutes, stirring occasionally, until the sauce is thick and heated through.', timerMinutes: 5 },
      { order: 6, instruction: 'Stir in the heavy cream and lemon juice. Gently fold in the pan-fried paneer cubes. Simmer for 3-4 minutes to let the paneer absorb some of the sauce flavors.', timerMinutes: 4 },
      { order: 7, instruction: 'Serve hot with naan bread, roti, or basmati rice.', timerMinutes: null },
    ],
    notes: 'Blanching the spinach and shocking it in ice water is the secret to a vibrant green sauce. Kasuri methi (dried fenugreek leaves), crushed and added with the cream, gives an authentic restaurant-style flavor. Firm tofu can replace paneer for a vegan version.',

    communityRating: 4.6,
    communityRatingCount: 302,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Chicken Biryani',
    description:
      'A magnificent Indian rice dish where fragrant basmati rice layered with spiced, yogurt-marinated chicken is slow-cooked together until every grain is infused with saffron, cardamom, and deep, complex flavors.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-biryani.jpg', caption: 'Layered chicken biryani with saffron rice', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-biryani-prep.jpg', caption: 'Layering rice and chicken in the pot', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 45,
    totalTime: 75,
    difficulty: 'hard',
    spiceLevel: 3,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: ['celebration', 'sunday-dinner', 'high-protein', 'gluten-free', 'dairy-free', 'date-night'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 580,
      protein: 34,
      carbs: 62,
      fat: 20,
      fiber: 3,
      sugar: 4,
      sodium: 740,
      iron: 3.8,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'basmati rice, soaked for 30 minutes', group: 'Rice' },
      { qty: 6, unit: 'cups', item: 'water for parboiling rice', group: 'Rice' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Rice' },
      { qty: 4, unit: '', item: 'green cardamom pods', group: 'Rice' },
      { qty: 4, unit: '', item: 'whole cloves', group: 'Rice' },
      { qty: 1, unit: '', item: 'cinnamon stick', group: 'Rice' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Rice' },
      { qty: 1.5, unit: 'lbs', item: 'bone-in chicken pieces (thighs and drumsticks)', group: 'Chicken' },
      { qty: 0.5, unit: 'cup', item: 'plain yogurt', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tbsp', item: 'ginger-garlic paste', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tsp', item: 'red chili powder', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tsp', item: 'turmeric', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tsp', item: 'garam masala', group: 'Chicken Marinade' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Chicken Marinade' },
      { qty: 3, unit: 'tbsp', item: 'ghee or vegetable oil', group: 'Cooking' },
      { qty: 2, unit: '', item: 'large onions, thinly sliced', group: 'Cooking' },
      { qty: 0.25, unit: 'tsp', item: 'saffron threads, soaked in 3 tbsp warm milk', group: 'Layering' },
      { qty: 2, unit: 'tbsp', item: 'fresh mint leaves, chopped', group: 'Layering' },
      { qty: 2, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Layering' },
      { qty: 1, unit: 'tbsp', item: 'ghee, cut into small pieces', group: 'Layering' },
    ],
    steps: [
      { order: 1, instruction: 'Marinate the chicken with yogurt, ginger-garlic paste, chili powder, turmeric, garam masala, and salt. Set aside for at least 30 minutes (or overnight for best results).', timerMinutes: 30 },
      { order: 2, instruction: 'Parboil the rice: bring 6 cups of water to a boil with bay leaves, cardamom, cloves, cinnamon, and salt. Add the soaked and drained rice. Cook for exactly 5 minutes until the rice is 70% done (firm in the center). Drain and set aside.', timerMinutes: 5 },
      { order: 3, instruction: 'Heat ghee in a large heavy-bottomed pot over medium heat. Fry the sliced onions for 12-15 minutes, stirring often, until deep golden brown and caramelized. Remove half for garnish.', timerMinutes: 15 },
      { order: 4, instruction: 'Add the marinated chicken to the pot with the remaining fried onions. Cook over medium-high heat for 8-10 minutes, turning occasionally, until the chicken is seared and the marinade has thickened.', timerMinutes: 10 },
      { order: 5, instruction: 'Spread the parboiled rice evenly over the chicken layer. Drizzle the saffron milk over the rice in lines. Scatter mint and cilantro on top, and dot with small pieces of ghee.', timerMinutes: null },
      { order: 6, instruction: 'Cover the pot tightly with aluminum foil, then place the lid on top to create a seal (dum). Cook over the lowest possible heat for 25 minutes. Do not open the lid during cooking.', timerMinutes: 25 },
      { order: 7, instruction: 'Remove from heat and let rest, still covered, for 5 minutes. Gently fluff with a fork, mixing the layers from bottom to top. Garnish with the reserved fried onions. Serve with raita.', timerMinutes: 5 },
    ],
    notes: 'The dum (sealed slow cooking) is what makes biryani special -- the chicken and rice steam together, exchanging flavors. Sealing with foil under the lid is crucial. Bone-in chicken gives more flavor but boneless thighs work too. Serve with raita (yogurt with cucumber and cumin) and a simple salad of sliced onions with lemon juice.',

    communityRating: 4.9,
    communityRatingCount: 378,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
];

export default asianRecipes;
